var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __restKey = (key) => typeof key === "symbol" ? key : key + "";
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __reExport = (target, module2, copyDefault, desc) => {
  if (module2 && typeof module2 === "object" || typeof module2 === "function") {
    for (let key of __getOwnPropNames(module2))
      if (!__hasOwnProp.call(target, key) && (copyDefault || key !== "default"))
        __defProp(target, key, { get: () => module2[key], enumerable: !(desc = __getOwnPropDesc(module2, key)) || desc.enumerable });
  }
  return target;
};
var __toESM = (module2, isNodeMode) => {
  return __reExport(__markAsModule(__defProp(module2 != null ? __create(__getProtoOf(module2)) : {}, "default", !isNodeMode && module2 && module2.__esModule ? { get: () => module2.default, enumerable: true } : { value: module2, enumerable: true })), module2);
};
var __toCommonJS = /* @__PURE__ */ ((cache2) => {
  return (module2, temp) => {
    return cache2 && cache2.get(module2) || (temp = __reExport(__markAsModule({}), module2, 1), cache2 && cache2.set(module2, temp), temp);
  };
})(typeof WeakMap !== "undefined" ? /* @__PURE__ */ new WeakMap() : 0);

// source/index.ts
var source_exports = {};
__export(source_exports, {
  UNSAFE_isNotApplicable: () => UNSAFE_isNotApplicable,
  capitalise0: () => capitalise0,
  default: () => Engine,
  formatValue: () => formatValue,
  isNotApplicable: () => isNotApplicable,
  isNotYetDefined: () => isNotYetDefined,
  parsePublicodes: () => parsePublicodes2,
  parseUnit: () => parseUnit,
  reduceAST: () => reduceAST,
  serializeEvaluation: () => serializeEvaluation,
  serializeUnit: () => serializeUnit,
  simplifyNodeUnit: () => simplifyNodeUnit,
  transformAST: () => makeASTTransformer,
  utils: () => ruleUtils_exports
});

// source/evaluationFunctions.ts
var evaluationFunctions = {
  constant: (node) => node
};
function registerEvaluationFunction(nodeKind, evaluationFunction) {
  evaluationFunctions != null ? evaluationFunctions : evaluationFunctions = {};
  if (evaluationFunctions[nodeKind]) {
    throw Error(`Multiple evaluation functions registered for the nodeKind \x1B[4m${nodeKind}`);
  }
  evaluationFunctions[nodeKind] = evaluationFunction;
}

// source/parse.ts
var import_nearley = __toESM(require("nearley"), 1);

// source/error.ts
var EngineError = class extends Error {
};
function syntaxError(dottedName, message, originalError) {
  throw new EngineError(`
[ Erreur syntaxique ]
\u27A1\uFE0F  Dans la r\xE8gle "${dottedName}"
\u2716\uFE0F  ${message}
    ${originalError ? originalError.message : ""}
`);
}
function warning(logger, rule, message, originalError) {
  logger.warn(`
[ Avertissement ]
\u27A1\uFE0F  Dans la r\xE8gle "${rule}"
\u26A0\uFE0F  ${message}
${originalError ? `\u2139\uFE0F  ${originalError.message}` : ""}
`);
}
function evaluationError(logger, rule, message, originalError) {
  logger.error(`
[ Erreur d'\xE9valuation ]
\u27A1\uFE0F  Dans la r\xE8gle "${rule}"
\u2716\uFE0F  ${message}
    ${originalError ? originalError.message : ""}
`);
}
function neverHappens(_) {
}
var InternalError = class extends EngineError {
  constructor(payload) {
    super(`
Erreur interne du moteur.

Cette erreur est le signe d'un bug dans publicodes. Pour nous aider \xE0 le r\xE9soudre, vous pouvez copier ce texte dans un nouveau ticket : https://github.com/betagouv/mon-entreprise/issues/new.

payload:
${JSON.stringify(payload, null, 2)}
`);
  }
};

// source/date.ts
function normalizeDateString(dateString) {
  let [day, month, year] = dateString.split("/");
  if (!year) {
    ;
    [day, month, year] = ["01", day, month];
  }
  return normalizeDate(+year, +month, +day);
}
var pad = (n) => +n < 10 ? `0${n}` : "" + n;
function normalizeDate(year, month, day) {
  const date2 = new Date(+year, +month - 1, +day);
  if (!+date2 || date2.getDate() !== +day) {
    throw new SyntaxError(`La date ${day}/${month}/${year} n'est pas valide`);
  }
  return `${pad(day)}/${pad(month)}/${pad(year)}`;
}
function convertToDate(value) {
  const [day, month, year] = normalizeDateString(value).split("/");
  const result = new Date(+year, +month - 1, +day);
  result.setMinutes(result.getMinutes() - result.getTimezoneOffset());
  return result;
}
function convertToString(date2) {
  return normalizeDate(date2.getFullYear(), date2.getMonth() + 1, date2.getDate());
}

// source/grammarFunctions.js
var binaryOperation = (operationType) => ([A, , operator, , B]) => ({
  [operator]: {
    operationType,
    explanation: [A, B]
  }
});
var unaryOperation = (operationType) => ([operator, , A]) => ({
  [operator]: {
    operationType,
    explanation: [number([{ value: "0" }]), A]
  }
});
var variable = ([firstFragment, nextFragment], _, reject) => {
  const fragments = [firstFragment, ...nextFragment].map(({ value }) => value);
  if (!nextFragment.length && ["oui", "non"].includes(firstFragment)) {
    return reject;
  }
  return {
    variable: fragments.join(" . ")
  };
};
var JSONObject = ([{ value }]) => {
  console.log(value);
};
var number = ([{ value }]) => ({
  constant: {
    type: "number",
    nodeValue: parseFloat(value)
  }
});
var numberWithUnit = (value) => __spreadProps(__spreadValues({}, number(value)), {
  unit\u00E9: value[2].value
});
var date = ([{ value }]) => {
  return {
    constant: {
      type: "date",
      nodeValue: normalizeDateString(value)
    }
  };
};
var boolean = (nodeValue) => () => ({
  constant: {
    type: "boolean",
    nodeValue
  }
});
var string = ([{ value }]) => ({
  constant: {
    type: "string",
    nodeValue: value.slice(1, -1)
  }
});

// source/grammar.js
var import_moo = __toESM(require("moo"), 1);
function id(x) {
  return x[0];
}
var dateRegexp = `(?:(?:0?[1-9]|[12][0-9]|3[01])\\/)?(?:0?[1-9]|1[012])\\/\\d{4}`;
var letter = "[a-zA-Z\xC0-\u017F\u20AC$%]";
var letterOrNumber = "[a-zA-Z\xC0-\u017F0-9'\xB0]";
var word = `${letter}(?:[-']?${letterOrNumber}+)*`;
var wordOrNumber = `(?:${word}|${letterOrNumber}+)`;
var words = `${word}(?:[,\\s]?${wordOrNumber}+)*`;
var periodWord = `\\| ${word}(?:[\\s]${word})*`;
var numberRegExp = "-?(?:[1-9][0-9]+|[0-9])(?:\\.[0-9]+)?";
var lexer = import_moo.default.compile({
  "(": "(",
  ")": ")",
  "[": "[",
  "]": "]",
  comparison: [">", "<", ">=", "<=", "=", "!="],
  infinity: "Infinity",
  colon: " : ",
  date: new RegExp(dateRegexp),
  periodWord: new RegExp(periodWord),
  words: new RegExp(words),
  number: new RegExp(numberRegExp),
  string: /'.*'/,
  JSONObject: /{.*}/,
  additionSubstraction: /[\+-]/,
  multiplicationDivision: ["*", "/"],
  dot: " . ",
  ".": ".",
  letterOrNumber: new RegExp(letterOrNumber),
  space: { match: /[\s]+/, lineBreaks: true }
});
var join = (args) => ({ value: args.map((x) => x && x.value).join("") });
var flattenJoin = ([a, b]) => Array.isArray(b) ? join([a, ...b]) : a;
var Lexer = lexer;
var ParserRules = [
  { "name": "main", "symbols": ["Comparison"], "postprocess": id },
  { "name": "main", "symbols": ["NumericValue"], "postprocess": id },
  { "name": "main", "symbols": ["Date"], "postprocess": id },
  { "name": "main", "symbols": ["NonNumericTerminal"], "postprocess": id },
  { "name": "main", "symbols": ["JSONObject"], "postprocess": id },
  { "name": "NumericValue", "symbols": ["AdditionSubstraction"], "postprocess": id },
  { "name": "NumericValue", "symbols": ["Negation"], "postprocess": id },
  { "name": "NumericTerminal", "symbols": ["Variable"], "postprocess": id },
  { "name": "NumericTerminal", "symbols": ["number"], "postprocess": id },
  { "name": "Negation", "symbols": [{ "literal": "-" }, lexer.has("space") ? { type: "space" } : space, "Parentheses"], "postprocess": unaryOperation("calculation") },
  { "name": "Parentheses", "symbols": [{ "literal": "(" }, lexer.has("space") ? { type: "space" } : space, "NumericValue", lexer.has("space") ? { type: "space" } : space, { "literal": ")" }], "postprocess": ([, , e]) => e },
  { "name": "Parentheses", "symbols": [{ "literal": "(" }, "NumericValue", { "literal": ")" }], "postprocess": ([, e]) => e },
  { "name": "Parentheses", "symbols": ["NumericTerminal"], "postprocess": id },
  { "name": "Date", "symbols": ["Variable"], "postprocess": id },
  { "name": "Date", "symbols": [lexer.has("date") ? { type: "date" } : date], "postprocess": date },
  { "name": "Comparison", "symbols": ["Comparable", lexer.has("space") ? { type: "space" } : space, lexer.has("comparison") ? { type: "comparison" } : comparison, lexer.has("space") ? { type: "space" } : space, "Comparable"], "postprocess": binaryOperation("comparison") },
  { "name": "Comparison", "symbols": ["Date", lexer.has("space") ? { type: "space" } : space, lexer.has("comparison") ? { type: "comparison" } : comparison, lexer.has("space") ? { type: "space" } : space, "Date"], "postprocess": binaryOperation("comparison") },
  { "name": "Comparable$subexpression$1", "symbols": ["AdditionSubstraction"] },
  { "name": "Comparable$subexpression$1", "symbols": ["NonNumericTerminal"] },
  { "name": "Comparable", "symbols": ["Comparable$subexpression$1"], "postprocess": ([[e]]) => e },
  { "name": "NonNumericTerminal", "symbols": ["boolean"], "postprocess": id },
  { "name": "NonNumericTerminal", "symbols": ["string"], "postprocess": id },
  { "name": "Variable$ebnf$1", "symbols": [] },
  { "name": "Variable$ebnf$1$subexpression$1", "symbols": [lexer.has("dot") ? { type: "dot" } : dot, lexer.has("words") ? { type: "words" } : words], "postprocess": ([, words2]) => words2 },
  { "name": "Variable$ebnf$1", "symbols": ["Variable$ebnf$1", "Variable$ebnf$1$subexpression$1"], "postprocess": function arrpush(d) {
    return d[0].concat([d[1]]);
  } },
  { "name": "Variable", "symbols": [lexer.has("words") ? { type: "words" } : words, "Variable$ebnf$1"], "postprocess": variable },
  { "name": "UnitDenominator$ebnf$1$subexpression$1", "symbols": [lexer.has("space") ? { type: "space" } : space] },
  { "name": "UnitDenominator$ebnf$1", "symbols": ["UnitDenominator$ebnf$1$subexpression$1"], "postprocess": id },
  { "name": "UnitDenominator$ebnf$1", "symbols": [], "postprocess": function(d) {
    return null;
  } },
  { "name": "UnitDenominator", "symbols": ["UnitDenominator$ebnf$1", { "literal": "/" }, lexer.has("words") ? { type: "words" } : words], "postprocess": join },
  { "name": "UnitNumerator$ebnf$1$subexpression$1", "symbols": [{ "literal": "." }, lexer.has("words") ? { type: "words" } : words] },
  { "name": "UnitNumerator$ebnf$1", "symbols": ["UnitNumerator$ebnf$1$subexpression$1"], "postprocess": id },
  { "name": "UnitNumerator$ebnf$1", "symbols": [], "postprocess": function(d) {
    return null;
  } },
  { "name": "UnitNumerator", "symbols": [lexer.has("words") ? { type: "words" } : words, "UnitNumerator$ebnf$1"], "postprocess": flattenJoin },
  { "name": "Unit$ebnf$1", "symbols": ["UnitNumerator"], "postprocess": id },
  { "name": "Unit$ebnf$1", "symbols": [], "postprocess": function(d) {
    return null;
  } },
  { "name": "Unit$ebnf$2", "symbols": [] },
  { "name": "Unit$ebnf$2", "symbols": ["Unit$ebnf$2", "UnitDenominator"], "postprocess": function arrpush2(d) {
    return d[0].concat([d[1]]);
  } },
  { "name": "Unit", "symbols": ["Unit$ebnf$1", "Unit$ebnf$2"], "postprocess": flattenJoin },
  { "name": "AdditionSubstraction", "symbols": ["AdditionSubstraction", lexer.has("space") ? { type: "space" } : space, lexer.has("additionSubstraction") ? { type: "additionSubstraction" } : additionSubstraction, lexer.has("space") ? { type: "space" } : space, "MultiplicationDivision"], "postprocess": binaryOperation("calculation") },
  { "name": "AdditionSubstraction", "symbols": ["MultiplicationDivision"], "postprocess": id },
  { "name": "MultiplicationDivision", "symbols": ["MultiplicationDivision", lexer.has("space") ? { type: "space" } : space, lexer.has("multiplicationDivision") ? { type: "multiplicationDivision" } : multiplicationDivision, lexer.has("space") ? { type: "space" } : space, "Parentheses"], "postprocess": binaryOperation("calculation") },
  { "name": "MultiplicationDivision", "symbols": ["Parentheses"], "postprocess": id },
  { "name": "boolean", "symbols": [{ "literal": "oui" }], "postprocess": boolean(true) },
  { "name": "boolean", "symbols": [{ "literal": "non" }], "postprocess": boolean(false) },
  { "name": "number", "symbols": [lexer.has("number") ? { type: "number" } : number], "postprocess": number },
  { "name": "number", "symbols": [lexer.has("infinity") ? { type: "infinity" } : infinity], "postprocess": number },
  { "name": "number$ebnf$1$subexpression$1", "symbols": [lexer.has("space") ? { type: "space" } : space] },
  { "name": "number$ebnf$1", "symbols": ["number$ebnf$1$subexpression$1"], "postprocess": id },
  { "name": "number$ebnf$1", "symbols": [], "postprocess": function(d) {
    return null;
  } },
  { "name": "number", "symbols": [lexer.has("number") ? { type: "number" } : number, "number$ebnf$1", "Unit"], "postprocess": numberWithUnit },
  { "name": "string", "symbols": [lexer.has("string") ? { type: "string" } : string], "postprocess": string },
  { "name": "JSONObject", "symbols": [lexer.has("JSONObject") ? { type: "JSONObject" } : JSONObject], "postprocess": JSONObject }
];
var ParserStart = "main";
var grammar_default = { Lexer, ParserRules, ParserStart };

// source/units.ts
var parseUnit = (string2, getUnitKey = (x) => x) => {
  const [a, ...b] = string2.split("/").map((u) => u.trim()), result = {
    numerators: a.split(".").filter(Boolean).map((unit) => getUnitKey(unit)),
    denominators: b.map((unit) => getUnitKey(unit))
  };
  return result;
};
var printUnits = (units, count, formatUnit2 = (x) => x) => units.sort().map((unit) => formatUnit2(unit, count)).join(".");
var plural = 2;
var serializeUnit = (rawUnit, count = plural, formatUnit2 = (x) => x) => {
  if (rawUnit === null || typeof rawUnit !== "object") {
    return typeof rawUnit === "string" ? formatUnit2(rawUnit, count) : rawUnit;
  }
  const unit = simplify(rawUnit), { numerators = [], denominators = [] } = unit;
  const n = numerators.length > 0;
  const d = denominators.length > 0;
  const string2 = !n && !d ? "" : n && !d ? printUnits(numerators, count, formatUnit2) : !n && d ? `/${printUnits(denominators, 1, formatUnit2)}` : `${printUnits(numerators, plural, formatUnit2)} / ${printUnits(denominators, 1, formatUnit2)}`;
  return string2;
};
var noUnit = { numerators: [], denominators: [] };
var inferUnit = (operator, rawUnits) => {
  if (operator === "/") {
    if (rawUnits.length !== 2)
      throw new Error("Infer units of a division with units.length !== 2)");
    return inferUnit("*", [
      rawUnits[0] || noUnit,
      {
        numerators: (rawUnits[1] || noUnit).denominators,
        denominators: (rawUnits[1] || noUnit).numerators
      }
    ]);
  }
  const units = rawUnits.filter(Boolean);
  if (units.length <= 1) {
    return units[0];
  }
  if (operator === "*")
    return simplify({
      numerators: units.flatMap((u) => {
        var _a;
        return (_a = u == null ? void 0 : u.numerators) != null ? _a : [];
      }),
      denominators: units.flatMap((u) => {
        var _a;
        return (_a = u == null ? void 0 : u.denominators) != null ? _a : [];
      })
    });
  if (operator === "-" || operator === "+") {
    return rawUnits.find((u) => u);
  }
  return void 0;
};
var equals = (a, b) => {
  if (Array.isArray(a) && Array.isArray(b)) {
    return a.length === b.length && a.every((_, i) => a[i] === b[i]);
  } else {
    return a === b;
  }
};
var removeOnce = (element, eqFn = equals) => (list) => {
  const index = list.findIndex((e) => eqFn(e, element));
  return list.filter((_, i) => i !== index);
};
var simplify = (unit, eqFn = equals) => [...unit.numerators, ...unit.denominators].reduce(({ numerators, denominators }, next) => numerators.find((u) => eqFn(next, u)) && denominators.find((u) => eqFn(next, u)) ? {
  numerators: removeOnce(next, eqFn)(numerators),
  denominators: removeOnce(next, eqFn)(denominators)
} : { numerators, denominators }, unit);
var convertTable = {
  "mois/an": 12,
  "jour/an": 365,
  "jour/mois": 365 / 12,
  "trimestre/an": 4,
  "mois/trimestre": 3,
  "jour/trimestre": 365 / 12 * 3,
  "\u20AC/k\u20AC": 10 ** 3,
  "g/kg": 10 ** 3,
  "mg/g": 10 ** 3,
  "mg/kg": 10 ** 6
};
function singleUnitConversionFactor(from, to) {
  return convertTable[`${to}/${from}`] || convertTable[`${from}/${to}`] && 1 / convertTable[`${from}/${to}`];
}
function unitsConversionFactor(from, to) {
  let factor = 100 ** (to.filter((unit) => unit === "%").length - from.filter((unit) => unit === "%").length);
  [factor] = from.reduce(([value, toUnits], fromUnit) => {
    const index = toUnits.findIndex((toUnit) => !!singleUnitConversionFactor(fromUnit, toUnit));
    const factor2 = singleUnitConversionFactor(fromUnit, toUnits[index]) || 1;
    return [
      value * factor2,
      [...toUnits.slice(0, index + 1), ...toUnits.slice(index + 1)]
    ];
  }, [factor, to]);
  return factor;
}
function convertUnit(from, to, value) {
  if (!areUnitConvertible(from, to)) {
    throw new Error(`Impossible de convertir l'unit\xE9 '${serializeUnit(from)}' en '${serializeUnit(to)}'`);
  }
  if (!value) {
    return value;
  }
  if (from === void 0) {
    return value;
  }
  const [fromSimplified, factorTo] = simplifyUnitWithValue(from || noUnit);
  const [toSimplified, factorFrom] = simplifyUnitWithValue(to || noUnit);
  return round(value * factorTo / factorFrom * unitsConversionFactor(fromSimplified.numerators, toSimplified.numerators) * unitsConversionFactor(toSimplified.denominators, fromSimplified.denominators));
}
var convertibleUnitClasses = unitClasses(convertTable);
function unitClasses(convertTable2) {
  return Object.keys(convertTable2).reduce((classes, ratio) => {
    const [a, b] = ratio.split("/");
    const ia = classes.findIndex((units) => units.has(a));
    const ib = classes.findIndex((units) => units.has(b));
    if (ia > -1 && ib > -1 && ia !== ib) {
      throw Error(`Invalid ratio ${ratio}`);
    } else if (ia === -1 && ib === -1) {
      classes.push(/* @__PURE__ */ new Set([a, b]));
    } else if (ia > -1) {
      classes[ia].add(b);
    } else if (ib > -1) {
      classes[ib].add(a);
    }
    return classes;
  }, []);
}
function areSameClass(a, b) {
  return a === b || convertibleUnitClasses.some((unitsClass) => unitsClass.has(a) && unitsClass.has(b));
}
function round(value) {
  return +value.toFixed(16);
}
function simplifyUnit(unit) {
  const { numerators, denominators } = simplify(unit, areSameClass);
  if (numerators.length && numerators.every((symb) => symb === "%")) {
    return { numerators: ["%"], denominators };
  }
  return removePercentages({ numerators, denominators });
}
function simplifyUnitWithValue(unit, value = 1) {
  const factor = unitsConversionFactor(unit.numerators, unit.denominators);
  return [
    simplify(removePercentages(unit), areSameClass),
    value ? round(value * factor) : value
  ];
}
var removePercentages = (unit) => ({
  numerators: unit.numerators.filter((e) => e !== "%"),
  denominators: unit.denominators.filter((e) => e !== "%")
});
function areUnitConvertible(a, b) {
  if (a == null || b == null) {
    return true;
  }
  const countByUnitClass = (units) => units.reduce((counters, unit) => {
    var _a;
    const classIndex = convertibleUnitClasses.findIndex((unitClass) => unitClass.has(unit));
    const key = classIndex === -1 ? unit : "" + classIndex;
    return __spreadProps(__spreadValues({}, counters), { [key]: 1 + ((_a = counters[key]) != null ? _a : 0) });
  }, {});
  const [numA, denomA, numB, denomB] = [
    a.numerators,
    a.denominators,
    b.numerators,
    b.denominators
  ].map(countByUnitClass);
  const uniq = (arr) => [...new Set(arr)];
  const unitClasses2 = [numA, denomA, numB, denomB].map(Object.keys).flat();
  return uniq(unitClasses2).every((unitClass) => (numA[unitClass] || 0) - (denomA[unitClass] || 0) === (numB[unitClass] || 0) - (denomB[unitClass] || 0) || unitClass === "%");
}

// source/nodeUnits.ts
function simplifyNodeUnit(node) {
  if (!node.unit) {
    return node;
  }
  const unit = simplifyUnit(node.unit);
  return convertNodeToUnit(unit, node);
}
function convertNodeToUnit(to, node) {
  return __spreadProps(__spreadValues({}, node), {
    nodeValue: node.unit && typeof node.nodeValue === "number" ? convertUnit(node.unit, to, node.nodeValue) : node.nodeValue,
    unit: to
  });
}

// source/evaluation.ts
var collectNodeMissing = (node) => "missingVariables" in node ? node.missingVariables : {};
var bonus = (missings = {}) => Object.fromEntries(Object.entries(missings).map(([key, value]) => [key, value + 1e-4]));
var mergeMissing = (left = {}, right = {}) => Object.fromEntries([...Object.keys(left), ...Object.keys(right)].map((key) => {
  var _a, _b;
  return [
    key,
    ((_a = left[key]) != null ? _a : 0) + ((_b = right[key]) != null ? _b : 0)
  ];
}));
var mergeAllMissing = (missings) => missings.map(collectNodeMissing).reduce(mergeMissing, {});
function convertNodesToSameUnit(nodes, mecanismName) {
  const firstNodeWithUnit = nodes.find((node) => !!node.unit);
  if (!firstNodeWithUnit) {
    return nodes;
  }
  return nodes.map((node) => {
    try {
      return convertNodeToUnit(firstNodeWithUnit.unit, node);
    } catch (e) {
      warning(this.options.logger, this.cache._meta.evaluationRuleStack[0], `Les unit\xE9s des \xE9l\xE9ments suivants sont incompatibles entre elles : 
		${(node == null ? void 0 : node.name) || (node == null ? void 0 : node.rawNode)}
		${(firstNodeWithUnit == null ? void 0 : firstNodeWithUnit.name) || (firstNodeWithUnit == null ? void 0 : firstNodeWithUnit.rawNode)}'`, e);
      return node;
    }
  });
}
var evaluateArray = (reducer, start) => function(node) {
  const evaluate23 = this.evaluate.bind(this);
  const evaluatedNodes = convertNodesToSameUnit.call(this, node.explanation.map(evaluate23), node.name);
  const values = evaluatedNodes.map(({ nodeValue: nodeValue2 }) => nodeValue2);
  const nodeValue = values.some((value) => value === void 0) ? void 0 : values.reduce(reducer, start);
  return __spreadProps(__spreadValues(__spreadProps(__spreadValues({}, node), {
    missingVariables: mergeAllMissing(evaluatedNodes),
    explanation: evaluatedNodes
  }), evaluatedNodes[0] && { unit: evaluatedNodes[0].unit }), {
    nodeValue
  });
};
var defaultNode = (nodeValue) => ({
  nodeValue,
  type: typeof nodeValue,
  isDefault: true,
  nodeKind: "constant"
});
var parseObject = (objectShape3, value, context) => {
  return Object.fromEntries(Object.entries(objectShape3).map(([key, defaultValue]) => {
    if (value[key] == void 0 && !defaultValue) {
      throw new Error(`Il manque une cl\xE9 '${key}' dans ${JSON.stringify(value)} `);
    }
    const parsedValue = value[key] != void 0 ? parse(value[key], context) : defaultValue;
    return [key, parsedValue];
  }));
};

// source/mecanisms/abattement.ts
var evaluateAbattement = function(node) {
  const assiette = this.evaluate(node.explanation.assiette);
  let abattement = this.evaluate(node.explanation.abattement);
  const percentageAbattement = serializeUnit(abattement.unit) === "%";
  if (assiette.unit && !percentageAbattement) {
    try {
      abattement = convertNodeToUnit(assiette.unit, abattement);
    } catch (e) {
      warning(this.options.logger, this.cache._meta.evaluationRuleStack[0], "Impossible de convertir les unit\xE9s de l'all\xE8gement entre elles", e);
    }
  }
  const assietteValue = assiette.nodeValue;
  const abattementValue = abattement.nodeValue;
  const nodeValue = abattementValue ? assietteValue == void 0 ? void 0 : abattementValue == void 0 ? assietteValue == 0 ? 0 : void 0 : serializeUnit(abattement.unit) === "%" ? Math.max(0, assietteValue - abattementValue / 100 * assietteValue) : Math.max(0, assietteValue - abattementValue) : assietteValue;
  return __spreadProps(__spreadValues({}, node), {
    nodeValue,
    unit: assiette.unit,
    missingVariables: mergeAllMissing([assiette, abattement]),
    explanation: {
      assiette,
      abattement
    }
  });
};
function parseAbattement(v, context) {
  const explanation = {
    assiette: parse(v.valeur, context),
    abattement: parse(v.abattement, context)
  };
  return {
    explanation,
    nodeKind: parseAbattement.nom
  };
}
parseAbattement.nom = "abattement";
registerEvaluationFunction(parseAbattement.nom, evaluateAbattement);

// source/mecanisms/applicable.ts
var evaluate = function(node) {
  const explanation = __spreadValues({}, node.explanation);
  const condition = this.evaluate(explanation.condition);
  let valeur = explanation.valeur;
  if (condition.nodeValue !== false) {
    valeur = this.evaluate(valeur);
  }
  return __spreadValues(__spreadProps(__spreadValues({}, node), {
    nodeValue: condition.nodeValue === void 0 ? void 0 : condition.nodeValue === null || condition.nodeValue === false ? null : valeur == null ? void 0 : valeur.nodeValue,
    explanation: { valeur, condition },
    missingVariables: mergeMissing("missingVariables" in valeur ? valeur.missingVariables : {}, bonus(condition.missingVariables))
  }), "unit" in valeur && { unit: valeur.unit });
};
parseApplicable.nom = "applicable si";
function parseApplicable(v, context) {
  const explanation = {
    valeur: parse(v.valeur, context),
    condition: parse(v[parseApplicable.nom], context)
  };
  return {
    explanation,
    nodeKind: parseApplicable.nom
  };
}
registerEvaluationFunction(parseApplicable.nom, evaluate);

// source/mecanisms/arrondi.ts
function roundWithPrecision(n, fractionDigits) {
  return +n.toFixed(fractionDigits);
}
var evaluate2 = function(node) {
  var _a;
  const valeur = simplifyNodeUnit(this.evaluate(node.explanation.valeur));
  const nodeValue = valeur.nodeValue;
  let arrondi = node.explanation.arrondi;
  if (nodeValue !== false) {
    arrondi = this.evaluate(arrondi);
    if (typeof arrondi.nodeValue === "number" && !((_a = serializeUnit(arrondi.unit)) == null ? void 0 : _a.match(/décimales?/))) {
      evaluationError(this.options.logger, this.cache._meta.evaluationRuleStack[0], `L'unit\xE9 ${serializeUnit(arrondi.unit)} de l'arrondi est inconnu. Vous devez utiliser l'unit\xE9 \u201Cd\xE9cimales\u201D`);
    }
  }
  return __spreadProps(__spreadValues({}, node), {
    nodeValue: typeof valeur.nodeValue !== "number" || !("nodeValue" in arrondi) ? valeur.nodeValue : typeof arrondi.nodeValue === "number" ? roundWithPrecision(valeur.nodeValue, arrondi.nodeValue) : arrondi.nodeValue === true ? roundWithPrecision(valeur.nodeValue, 0) : arrondi.nodeValue === void 0 ? void 0 : valeur.nodeValue,
    explanation: { valeur, arrondi },
    missingVariables: mergeAllMissing([valeur, arrondi]),
    unit: valeur.unit
  });
};
function parseArrondi(v, context) {
  const explanation = {
    valeur: parse(v.valeur, context),
    arrondi: parse(v.arrondi, context)
  };
  return {
    explanation,
    nodeKind: parseArrondi.nom
  };
}
parseArrondi.nom = "arrondi";
registerEvaluationFunction(parseArrondi.nom, evaluate2);

// source/mecanisms/trancheUtils.ts
var parseTranches = (tranches, context) => {
  return tranches.map((t, i) => {
    var _a;
    if (!t.plafond && i > tranches.length) {
      throw new SyntaxError(`La tranche n\xB0${i} du bar\xE8me n'a pas de plafond pr\xE9cis\xE9. Seule la derni\xE8re tranche peut ne pas \xEAtre plafonn\xE9e`);
    }
    return __spreadProps(__spreadValues({}, t), { plafond: (_a = t.plafond) != null ? _a : Infinity });
  }).map((node) => __spreadProps(__spreadValues(__spreadValues(__spreadValues({}, node), node.taux !== void 0 ? { taux: parse(node.taux, context) } : {}), node.montant !== void 0 ? { montant: parse(node.montant, context) } : {}), {
    plafond: parse(node.plafond, context)
  }));
};
function evaluatePlafondUntilActiveTranche({ multiplicateur, assiette, parsedTranches }) {
  return parsedTranches.reduce(([tranches, activeTrancheFound], parsedTranche, i) => {
    if (activeTrancheFound) {
      return [
        [...tranches, __spreadProps(__spreadValues({}, parsedTranche), { isAfterActive: true })],
        activeTrancheFound
      ];
    }
    const plafond = this.evaluate(parsedTranche.plafond);
    const plancher = tranches[i - 1] ? tranches[i - 1].plafond : { nodeValue: 0 };
    let plafondValue = plafond.nodeValue === void 0 || multiplicateur.nodeValue === void 0 ? void 0 : plafond.nodeValue * multiplicateur.nodeValue;
    try {
      plafondValue = plafondValue === Infinity || plafondValue === 0 ? plafondValue : convertUnit(inferUnit("*", [plafond.unit, multiplicateur.unit]), assiette.unit, plafondValue);
    } catch (e) {
      warning(this.options.logger, this.cache._meta.evaluationRuleStack[0], `L'unit\xE9 du plafond de la tranche n\xB0${i + 1}  n'est pas compatible avec celle l'assiette`, e);
    }
    const plancherValue = tranches[i - 1] ? tranches[i - 1].plafondValue : 0;
    const isAfterActive = plancherValue === void 0 || assiette.nodeValue === void 0 ? void 0 : plancherValue > assiette.nodeValue;
    const calculationValues = [plafond, assiette, multiplicateur, plancher];
    if (calculationValues.some((node) => node.nodeValue === void 0)) {
      return [
        [
          ...tranches,
          __spreadProps(__spreadValues({}, parsedTranche), {
            plafond,
            plafondValue,
            plancherValue,
            nodeValue: void 0,
            isActive: void 0,
            isAfterActive,
            missingVariables: mergeAllMissing(calculationValues)
          })
        ],
        false
      ];
    }
    if (!!tranches[i - 1] && !!plancherValue && plafondValue <= plancherValue) {
      evaluationError(this.options.logger, this.cache._meta.evaluationRuleStack[0], `Le plafond de la tranche n\xB0${i + 1} a une valeur inf\xE9rieure \xE0 celui de la tranche pr\xE9c\xE9dente`);
    }
    const tranche = __spreadProps(__spreadValues({}, parsedTranche), {
      plafond,
      plancherValue,
      plafondValue,
      isAfterActive,
      isActive: assiette.nodeValue >= plancherValue && assiette.nodeValue < plafondValue
    });
    return [[...tranches, tranche], tranche.isActive];
  }, [[], false])[0];
}

// source/mecanisms/barème.ts
function parseBar\u00E8me(v, context) {
  const explanation = {
    assiette: parse(v.assiette, context),
    multiplicateur: v.multiplicateur ? parse(v.multiplicateur, context) : defaultNode(1),
    tranches: parseTranches(v.tranches, context)
  };
  return {
    explanation,
    nodeKind: "bar\xE8me"
  };
}
function evaluateBar\u00E8me(tranches, assiette, evaluate23) {
  return tranches.map((tranche) => {
    if (tranche.isAfterActive) {
      return __spreadProps(__spreadValues({}, tranche), { nodeValue: 0 });
    }
    const taux = evaluate23(tranche.taux);
    const missingVariables = mergeAllMissing([taux, tranche]);
    if ([
      assiette.nodeValue,
      taux.nodeValue,
      tranche.plafondValue,
      tranche.plancherValue
    ].some((value) => value === void 0)) {
      return __spreadProps(__spreadValues({}, tranche), {
        taux,
        nodeValue: void 0,
        missingVariables
      });
    }
    return __spreadProps(__spreadValues(__spreadProps(__spreadValues({}, tranche), {
      taux
    }), "unit" in assiette && { unit: assiette.unit }), {
      nodeValue: (Math.min(assiette.nodeValue, tranche.plafondValue) - tranche.plancherValue) * convertUnit(taux.unit, parseUnit(""), taux.nodeValue),
      missingVariables
    });
  });
}
var evaluate3 = function(node) {
  const evaluate23 = this.evaluate.bind(this);
  const assiette = this.evaluate(node.explanation.assiette);
  const multiplicateur = this.evaluate(node.explanation.multiplicateur);
  const tranches = evaluateBar\u00E8me(evaluatePlafondUntilActiveTranche.call(this, {
    parsedTranches: node.explanation.tranches,
    assiette,
    multiplicateur
  }), assiette, evaluate23);
  const nodeValue = tranches.reduce((value, { nodeValue: nodeValue2 }) => nodeValue2 == void 0 ? void 0 : value + nodeValue2, 0);
  return __spreadProps(__spreadValues({}, node), {
    nodeValue,
    missingVariables: mergeAllMissing([assiette, multiplicateur, ...tranches]),
    explanation: {
      assiette,
      multiplicateur,
      tranches
    },
    unit: assiette.unit
  });
};
registerEvaluationFunction("bar\xE8me", evaluate3);

// source/mecanisms/composantes.ts
var decompose = (k, v, context) => {
  const _a = v, { composantes } = _a, factoredKeys = __objRest(_a, ["composantes"]);
  const explanation = parse({
    somme: composantes.map((composante) => {
      const _a2 = composante, { attributs } = _a2, otherKeys = __objRest(_a2, ["attributs"]);
      return __spreadProps(__spreadValues({}, attributs), {
        [k]: __spreadValues(__spreadValues({}, factoredKeys), otherKeys)
      });
    })
  }, context);
  return __spreadProps(__spreadValues({}, explanation), {
    visualisationKind: "composantes"
  });
};

// source/mecanisms/condition-allof.ts
var evaluate4 = function(node) {
  const [nodeValue, explanation] = node.explanation.reduce(([nodeValue2, explanation2], node2) => {
    if (nodeValue2 === false) {
      return [nodeValue2, [...explanation2, node2]];
    }
    const evaluatedNode = this.evaluate(node2);
    return [
      nodeValue2 === void 0 || evaluatedNode.nodeValue === void 0 ? void 0 : !!evaluatedNode.nodeValue,
      [...explanation2, evaluatedNode]
    ];
  }, [true, []]);
  return __spreadProps(__spreadValues({}, node), {
    nodeValue,
    explanation,
    missingVariables: mergeAllMissing(explanation)
  });
};
var mecanismAllOf = (v, context) => {
  if (!Array.isArray(v))
    throw new Error("should be array");
  const explanation = v.map((node) => parse(node, context));
  return {
    explanation,
    nodeKind: "toutes ces conditions"
  };
};
registerEvaluationFunction("toutes ces conditions", evaluate4);

// source/mecanisms/condition-oneof.ts
var evaluate5 = function(node) {
  const calculations = node.explanation.reduce((acc, node2) => {
    if (acc.nodeValue === true) {
      return __spreadProps(__spreadValues({}, acc), {
        explanation: [...acc.explanation, node2]
      });
    }
    if (acc.nodeValue === void 0 || acc.nodeValue === false) {
      const evaluatedNode = this.evaluate(node2);
      return {
        nodeValue: evaluatedNode.nodeValue ? true : evaluatedNode.nodeValue === void 0 ? void 0 : acc.nodeValue,
        missingVariables: mergeMissing(acc.missingVariables, evaluatedNode.missingVariables),
        explanation: [...acc.explanation, evaluatedNode]
      };
    }
    throw new InternalError([node2, acc]);
  }, {
    nodeValue: false,
    missingVariables: {},
    explanation: []
  });
  return __spreadValues(__spreadValues({}, node), calculations);
};
var mecanismOneOf = (v, context) => {
  if (!Array.isArray(v))
    throw new Error("should be array");
  const explanation = v.map((node) => parse(node, context));
  return {
    explanation,
    nodeKind: "une de ces conditions"
  };
};
registerEvaluationFunction("une de ces conditions", evaluate5);

// source/mecanisms/durée.ts
var todayString = convertToString(new Date());
var objectShape = {
  depuis: defaultNode(todayString),
  "jusqu'\xE0": defaultNode(todayString)
};
var evaluate6 = function(node) {
  const from = this.evaluate(node.explanation.depuis);
  const to = this.evaluate(node.explanation["jusqu'\xE0"]);
  let nodeValue;
  if ([from, to].some(({ nodeValue: nodeValue2 }) => nodeValue2 === void 0)) {
    nodeValue = void 0;
  } else {
    const [fromDate, toDate] = [from.nodeValue, to.nodeValue].map(convertToDate);
    nodeValue = Math.max(0, Math.round((toDate.getTime() - fromDate.getTime()) / (1e3 * 60 * 60 * 24)));
  }
  const missingVariables = mergeAllMissing([from, to]);
  return __spreadProps(__spreadValues({}, node), {
    missingVariables,
    nodeValue,
    explanation: {
      depuis: from,
      "jusqu'\xE0": to
    }
  });
};
var dur_e_default = (v, context) => {
  const explanation = parseObject(objectShape, v, context);
  return {
    explanation,
    unit: parseUnit("jour"),
    nodeKind: "dur\xE9e"
  };
};
registerEvaluationFunction("dur\xE9e", evaluate6);

// source/mecanisms/grille.ts
function parseGrille(v, context) {
  const explanation = {
    assiette: parse(v.assiette, context),
    multiplicateur: v.multiplicateur ? parse(v.multiplicateur, context) : defaultNode(1),
    tranches: parseTranches(v.tranches, context)
  };
  return {
    explanation,
    nodeKind: "grille"
  };
}
var evaluate7 = function(node) {
  var _a, _b;
  const evaluate23 = this.evaluate.bind(this);
  const assiette = this.evaluate(node.explanation.assiette);
  const multiplicateur = this.evaluate(node.explanation.multiplicateur);
  const tranches = evaluatePlafondUntilActiveTranche.call(this, {
    parsedTranches: node.explanation.tranches,
    assiette,
    multiplicateur
  }).map((tranche) => {
    if (tranche.isActive === false) {
      return tranche;
    }
    const montant = evaluate23(tranche.montant);
    return __spreadProps(__spreadValues({}, tranche), {
      montant,
      nodeValue: montant.nodeValue,
      unit: montant.unit,
      missingVariables: mergeAllMissing([montant, tranche])
    });
  });
  let activeTranches;
  const activeTranche = tranches.find((tranche) => tranche.isActive);
  if (activeTranche) {
    activeTranches = [activeTranche];
  } else if (tranches[tranches.length - 1].isAfterActive === false) {
    activeTranches = [{ nodeValue: false }];
  } else {
    activeTranches = tranches.filter((tranche) => tranche.isActive === void 0);
  }
  const nodeValue = !activeTranches[0] ? false : activeTranches[0].isActive === void 0 ? void 0 : activeTranches[0].nodeValue;
  return __spreadProps(__spreadValues({}, node), {
    nodeValue,
    missingVariables: mergeAllMissing([
      assiette,
      multiplicateur,
      ...activeTranches
    ]),
    explanation: __spreadProps(__spreadValues({}, node.explanation), {
      assiette,
      multiplicateur,
      tranches
    }),
    unit: (_b = (_a = activeTranches[0]) == null ? void 0 : _a.unit) != null ? _b : void 0
  });
};
registerEvaluationFunction("grille", evaluate7);

// source/uniroot.ts
function uniroot(func, lowerLimit, upperLimit, errorTol = 0, maxIter = 100, acceptableErrorTol = 0) {
  let a = lowerLimit, b = upperLimit, c = a, fa = func(a), fb = func(b), fc = fa, actualTolerance, newStep, prevStep, p, q, fallback = void 0;
  while (maxIter-- > 0) {
    prevStep = b - a;
    if (Math.abs(fc) < Math.abs(fb)) {
      ;
      a = b, b = c, c = a;
      fa = fb, fb = fc, fc = fa;
    }
    actualTolerance = 1e-15 * Math.abs(b) + errorTol / 2;
    newStep = (c - b) / 2;
    if (Math.abs(newStep) <= actualTolerance || fb === 0) {
      return b;
    }
    if (Math.abs(prevStep) >= actualTolerance && Math.abs(fa) > Math.abs(fb)) {
      let t1, t2;
      const cb = c - b;
      if (a === c) {
        t1 = fb / fa;
        p = cb * t1;
        q = 1 - t1;
      } else {
        ;
        q = fa / fc, t1 = fb / fc, t2 = fb / fa;
        p = t2 * (cb * q * (q - t1) - (b - a) * (t1 - 1));
        q = (q - 1) * (t1 - 1) * (t2 - 1);
      }
      if (p > 0) {
        q = -q;
      } else {
        p = -p;
      }
      if (p < 0.75 * cb * q - Math.abs(actualTolerance * q) / 2 && p < Math.abs(prevStep * q / 2)) {
        newStep = p / q;
      }
    }
    if (Math.abs(newStep) < actualTolerance) {
      newStep = newStep > 0 ? actualTolerance : -actualTolerance;
    }
    ;
    a = b, fa = fb;
    b += newStep, fb = func(b);
    if (fb > 0 && fc > 0 || fb < 0 && fc < 0) {
      ;
      c = a, fc = fa;
    }
    if (Math.abs(fb) < errorTol) {
      return b;
    }
    if (Math.abs(fb) < acceptableErrorTol) {
      fallback = b;
    }
  }
  return fallback;
}

// source/mecanisms/inversion.ts
var evaluateInversion = function(node) {
  const inversionGoal = node.explanation.inversionCandidates.find((candidate) => this.parsedSituation[candidate.dottedName] != void 0);
  if (inversionGoal === void 0) {
    const missingVariables2 = __spreadProps(__spreadValues({}, Object.fromEntries(node.explanation.inversionCandidates.map((candidate) => [
      candidate.dottedName,
      1
    ]))), {
      [node.explanation.ruleToInverse]: 1
    });
    return __spreadProps(__spreadValues({}, node), {
      missingVariables: missingVariables2,
      nodeValue: void 0
    });
  }
  const evaluatedInversionGoal = this.evaluate(inversionGoal);
  const unit = "unit" in node ? node.unit : evaluatedInversionGoal.unit;
  const originalCache = this.cache;
  const originalSituation = __spreadValues({}, this.parsedSituation);
  let inversionNumberOfIterations = 0;
  delete this.parsedSituation[inversionGoal.dottedName];
  const evaluateWithValue = (n) => {
    inversionNumberOfIterations++;
    this.resetCache();
    this.cache._meta = __spreadValues({}, originalCache._meta);
    this.parsedSituation[node.explanation.ruleToInverse] = {
      unit,
      nodeKind: "unit\xE9",
      explanation: {
        nodeKind: "constant",
        nodeValue: n,
        type: "number"
      }
    };
    return convertNodeToUnit(unit, this.evaluate(inversionGoal));
  };
  const goal = convertNodeToUnit(unit, evaluatedInversionGoal).nodeValue;
  let nodeValue = void 0;
  const x1 = goal;
  const y1Node = evaluateWithValue(x1);
  const y1 = y1Node.nodeValue;
  const coeff = y1 > goal ? 0.9 : 1.2;
  const x2 = y1 !== void 0 ? x1 * goal * coeff / y1 : 2e3;
  const y2Node = evaluateWithValue(x2);
  const y2 = y2Node.nodeValue;
  const missingVariables = mergeMissing(y1Node.missingVariables, y2Node.missingVariables);
  if (y1 !== void 0 || y2 !== void 0) {
    const test = (x) => {
      const y = x === x1 ? y1 : x === x2 ? y2 : evaluateWithValue(x).nodeValue;
      return y - goal;
    };
    const defaultMin = -1e6;
    const defaultMax = 1e8;
    const nearestBelowGoal = y2 !== void 0 && y2 < goal && (y2 > y1 || y1 > goal) ? x2 : y1 !== void 0 && y1 < goal && (y1 > y2 || y2 > goal) ? x1 : defaultMin;
    const nearestAboveGoal = y2 !== void 0 && y2 > goal && (y2 < y1 || y1 < goal) ? x2 : y1 !== void 0 && y1 > goal && (y1 < y2 || y2 < goal) ? x1 : defaultMax;
    nodeValue = uniroot(test, nearestBelowGoal, nearestAboveGoal, 0.1, 10, 1);
  }
  if (nodeValue === void 0) {
    nodeValue = void 0;
    originalCache._meta.inversionFail = true;
  }
  this.cache = originalCache;
  this.parsedSituation = originalSituation;
  return __spreadProps(__spreadValues({}, node), {
    unit,
    nodeValue,
    explanation: __spreadProps(__spreadValues({}, node.explanation), {
      inversionGoal,
      inversionNumberOfIterations
    }),
    missingVariables
  });
};
var mecanismInversion = (v, context) => {
  if (!v.avec) {
    throw new Error("Une formule d'inversion doit pr\xE9ciser _avec_ quoi on peut inverser la variable");
  }
  return __spreadProps(__spreadValues({
    explanation: {
      ruleToInverse: context.dottedName,
      inversionCandidates: v.avec.map((node) => __spreadValues({}, parse(node, __spreadProps(__spreadValues({}, context), { circularReferences: true }))))
    }
  }, "unit\xE9" in v && {
    unit: parseUnit(v.unit\u00E9, context.getUnitKey)
  }), {
    nodeKind: "inversion"
  });
};
registerEvaluationFunction("inversion", evaluateInversion);

// source/mecanisms/max.ts
var mecanismMax = (v, context) => {
  const explanation = v.map((node) => parse(node, context));
  return {
    explanation,
    nodeKind: "maximum"
  };
};
var max = (a, b) => {
  if (a === null) {
    return b;
  }
  if (b === null) {
    return a;
  }
  if (a === void 0 || b === void 0) {
    return void 0;
  }
  return Math.max(a, b);
};
var evaluate8 = evaluateArray(max, null);
registerEvaluationFunction("maximum", evaluate8);

// source/mecanisms/texte.ts
var NAME = "texte";
function parseTexte(texte, context) {
  const explanation = [];
  let lastIndex = 0;
  for (const { 0: expression, index } of texte.matchAll(/{{(.|\n)*?}}/g)) {
    const publicodeExpression = expression.slice(2, -2).trim();
    const parsedNode = parse(publicodeExpression, context);
    explanation.push(texte.substring(lastIndex, index), parsedNode);
    lastIndex = (index != null ? index : 0) + expression.length;
  }
  explanation.push(texte.slice(lastIndex));
  return {
    nodeKind: NAME,
    explanation
  };
}
parseTexte.nom = NAME;
registerEvaluationFunction(NAME, function evaluate9(node) {
  const explanation = node.explanation.map((element) => typeof element === "string" ? element : this.evaluate(element));
  const missingVariables = mergeAllMissing(node.explanation.filter((element) => typeof element !== "string"));
  return __spreadProps(__spreadValues({}, node), {
    explanation,
    missingVariables,
    nodeValue: explanation.map((element) => typeof element === "string" ? element : formatValue(element)).join("")
  });
});

// source/mecanisms/min.ts
var mecanismMin = (v, context) => {
  const explanation = v.map((node) => parse(node, context));
  return {
    explanation,
    nodeKind: "minimum"
  };
};
var min = (a, b) => {
  if (a === null) {
    return b;
  }
  if (b === null) {
    return a;
  }
  if (a === void 0 || b === void 0) {
    return void 0;
  }
  return Math.min(a, b);
};
var evaluate10 = evaluateArray(min, null);
registerEvaluationFunction("minimum", evaluate10);

// source/mecanisms/nonApplicable.ts
var evaluate11 = function(node) {
  const condition = this.evaluate(node.explanation.condition);
  let valeur = node.explanation.valeur;
  if (condition.nodeValue === false || condition.nodeValue === null) {
    valeur = this.evaluate(valeur);
  }
  return __spreadValues(__spreadProps(__spreadValues({}, node), {
    nodeValue: condition.nodeValue === void 0 ? void 0 : condition.nodeValue !== false && condition.nodeValue !== null ? null : "nodeValue" in valeur ? valeur.nodeValue : void 0,
    explanation: { valeur, condition },
    missingVariables: mergeMissing("missingVariables" in valeur ? valeur.missingVariables : {}, bonus(condition.missingVariables))
  }), "unit" in valeur && { unit: valeur.unit });
};
function parseNonApplicable(v, context) {
  const explanation = {
    valeur: parse(v.valeur, context),
    condition: parse(v[parseNonApplicable.nom], context)
  };
  return {
    explanation,
    nodeKind: parseNonApplicable.nom
  };
}
parseNonApplicable.nom = "non applicable si";
registerEvaluationFunction(parseNonApplicable.nom, evaluate11);

// source/mecanisms/one-possibility.ts
var mecanismOnePossibility = (v, context) => {
  if (Array.isArray(v)) {
    v = {
      possibilit\u00E9s: v
    };
  }
  return __spreadProps(__spreadValues({}, v), {
    explanation: v.possibilit\u00E9s.map((p) => parse(p, __spreadProps(__spreadValues({}, context), { circularReferences: true }))),
    nodeKind: "une possibilit\xE9",
    context: context.dottedName
  });
};
registerEvaluationFunction("une possibilit\xE9", (node) => __spreadProps(__spreadValues({}, node), {
  nodeValue: void 0,
  missingVariables: { [node.context]: 1 }
}));

// source/mecanisms/operation.ts
var knownOperations = {
  "*": [(a, b) => a * b, "\xD7"],
  "/": [(a, b) => a / b, "\u2215"],
  "+": [(a, b) => a + b],
  "-": [(a, b) => a - b, "\u2212"],
  "<": [(a, b) => a < b],
  "<=": [(a, b) => a <= b, "\u2264"],
  ">": [(a, b) => a > b],
  ">=": [(a, b) => a >= b, "\u2265"],
  "=": [(a, b) => a === b],
  "!=": [(a, b) => a !== b, "\u2260"]
};
var parseOperation = (k, symbol) => (v, context) => {
  const explanation = v.explanation.map((node) => parse(node, context));
  return __spreadProps(__spreadValues({}, v), {
    nodeKind: "operation",
    operationKind: k,
    operator: symbol || k,
    explanation
  });
};
var evaluate12 = function(node) {
  const explanation = node.explanation.map((node3) => this.evaluate(node3));
  let [node1, node2] = explanation;
  const missingVariables = mergeAllMissing([node1, node2]);
  if (node1.nodeValue === void 0 || node2.nodeValue === void 0) {
    return __spreadProps(__spreadValues({}, node), { nodeValue: void 0, explanation, missingVariables });
  }
  if (!["\u2215", "\xD7"].includes(node.operator)) {
    try {
      if (node1.unit && "unit" in node2) {
        node2 = convertNodeToUnit(node1.unit, node2);
      } else if (node2.unit) {
        node1 = convertNodeToUnit(node2.unit, node1);
      }
    } catch (e) {
      warning(this.options.logger, `Dans l'expression '${node.operator}', la partie gauche (unit\xE9: ${serializeUnit(node1.unit)}) n'est pas compatible avec la partie droite (unit\xE9: ${serializeUnit(node2.unit)})`, e);
    }
  }
  const operatorFunction = knownOperations[node.operationKind][0];
  const a = node1.nodeValue;
  const b = node2.nodeValue;
  const nodeValue = a === void 0 || b === void 0 ? void 0 : a === null || b === null || typeof a === "boolean" || typeof b === "boolean" ? node.operator === "=" ? (a === null ? false : a) === (b === null ? false : b) : node.operator === "\u2260" ? (a === null ? false : a) !== (b === null ? false : b) : ["*", "/", "+", "-"].includes(node.operator) ? operatorFunction(a === null ? 0 : a, b === null ? 0 : b) : false : ["\u2260", "=", "<", ">", "\u2264", "\u2265"].includes(node.operator) && [a, b].every((value) => {
    var _a;
    return (_a = value.match) == null ? void 0 : _a.call(value, /[\d]{2}\/[\d]{2}\/[\d]{4}/);
  }) ? operatorFunction(convertToDate(a), convertToDate(b)) : operatorFunction(a, b);
  return __spreadProps(__spreadValues(__spreadProps(__spreadValues({}, node), {
    explanation
  }), (node.operationKind === "*" || node.operationKind === "/" || node.operationKind === "-" || node.operationKind === "+") && {
    unit: inferUnit(node.operationKind, [node1.unit, node2.unit])
  }), {
    missingVariables,
    nodeValue
  });
};
registerEvaluationFunction("operation", evaluate12);
var operationDispatch = Object.fromEntries(Object.entries(knownOperations).map(([k, [f, symbol]]) => [
  k,
  parseOperation(k, symbol)
]));
var operation_default = operationDispatch;

// source/mecanisms/parDéfaut.ts
var evaluate13 = function(node) {
  const explanation = __spreadValues({}, node.explanation);
  let valeur = this.evaluate(explanation.valeur);
  explanation.valeur = valeur;
  if (valeur.nodeValue === void 0) {
    valeur = this.evaluate(explanation.parD\u00E9faut);
    explanation.parD\u00E9faut = valeur;
  }
  return __spreadValues(__spreadProps(__spreadValues({}, node), {
    nodeValue: valeur.nodeValue,
    explanation,
    missingVariables: mergeMissing(bonus(explanation.valeur.missingVariables), "missingVariables" in explanation.parD\u00E9faut ? explanation.parD\u00E9faut.missingVariables : {})
  }), "unit" in valeur && { unit: valeur.unit });
};
function parseParD\u00E9faut(v, context) {
  const explanation = {
    valeur: parse(v.valeur, context),
    parD\u00E9faut: parse(v["par d\xE9faut"], context)
  };
  return {
    explanation,
    nodeKind: parseParD\u00E9faut.nom
  };
}
parseParD\u00E9faut.nom = "par d\xE9faut";
registerEvaluationFunction(parseParD\u00E9faut.nom, evaluate13);

// source/mecanisms/plafond.ts
var evaluate14 = function(node) {
  const valeur = this.evaluate(node.explanation.valeur);
  let nodeValue = valeur.nodeValue;
  let plafond = node.explanation.plafond;
  if (nodeValue !== false) {
    const evaluatedPlafond = this.evaluate(plafond);
    if (valeur.unit) {
      try {
        plafond = convertNodeToUnit(valeur.unit, evaluatedPlafond);
      } catch (e) {
        warning(this.options.logger, this.cache._meta.evaluationRuleStack[0], "L'unit\xE9 du plafond n'est pas compatible avec celle de la valeur \xE0 encadrer", e);
      }
    }
  }
  if (typeof nodeValue === "number" && "nodeValue" in plafond && typeof plafond.nodeValue === "number" && nodeValue > plafond.nodeValue) {
    nodeValue = plafond.nodeValue;
    plafond.isActive = true;
  }
  return __spreadProps(__spreadValues(__spreadProps(__spreadValues({}, node), {
    nodeValue
  }), "unit" in valeur && { unit: valeur.unit }), {
    explanation: { valeur, plafond },
    missingVariables: mergeAllMissing([valeur, plafond])
  });
};
function parsePlafond(v, context) {
  const explanation = {
    valeur: parse(v.valeur, context),
    plafond: parse(v.plafond, context)
  };
  return {
    explanation,
    nodeKind: "plafond"
  };
}
parsePlafond.nom = "plafond";
registerEvaluationFunction("plafond", evaluate14);

// source/mecanisms/plancher.ts
var evaluate15 = function(node) {
  const valeur = this.evaluate(node.explanation.valeur);
  let nodeValue = valeur.nodeValue;
  let plancher = node.explanation.plancher;
  if (nodeValue !== false) {
    const evaluatedPlancher = this.evaluate(plancher);
    if (valeur.unit) {
      try {
        plancher = convertNodeToUnit(valeur.unit, evaluatedPlancher);
      } catch (e) {
        warning(this.options.logger, this.cache._meta.evaluationRuleStack[0], "L'unit\xE9 du plancher n'est pas compatible avec celle de la valeur \xE0 encadrer", e);
      }
    }
  }
  if (typeof nodeValue === "number" && "nodeValue" in plancher && typeof plancher.nodeValue === "number" && nodeValue < plancher.nodeValue) {
    nodeValue = plancher.nodeValue;
    plancher.isActive = true;
  }
  return __spreadProps(__spreadValues(__spreadProps(__spreadValues({}, node), {
    nodeValue
  }), "unit" in valeur && { unit: valeur.unit }), {
    explanation: { valeur, plancher },
    missingVariables: mergeAllMissing([valeur, plancher])
  });
};
function Plancher(v, context) {
  const explanation = {
    valeur: parse(v.valeur, context),
    plancher: parse(v.plancher, context)
  };
  return {
    explanation,
    nodeKind: "plancher"
  };
}
Plancher.nom = "plancher";
registerEvaluationFunction("plancher", evaluate15);

// source/mecanisms/product.ts
var objectShape2 = {
  assiette: false,
  taux: defaultNode(1),
  facteur: defaultNode(1),
  plafond: defaultNode(Infinity)
};
var mecanismProduct = (v, context) => {
  const explanation = parseObject(objectShape2, v, context);
  return {
    explanation,
    nodeKind: "produit"
  };
};
var evaluateProduit = function(node) {
  const assiette = this.evaluate(node.explanation.assiette);
  const taux = this.evaluate(node.explanation.taux);
  const facteur = this.evaluate(node.explanation.facteur);
  let plafond = this.evaluate(node.explanation.plafond);
  if (assiette.unit) {
    try {
      plafond = convertNodeToUnit(assiette.unit, plafond);
    } catch (e) {
      warning(this.options.logger, this.cache._meta.evaluationRuleStack[0], "Impossible de convertir l'unit\xE9 du plafond du produit dans celle de l'assiette", e);
    }
  }
  const mult = (base, rate, facteur2, plafond2) => Math.min(base, plafond2 === null || plafond2 === false ? Infinity : plafond2) * rate * facteur2;
  let nodeValue = [taux, assiette, facteur].some((n) => n.nodeValue === void 0) ? void 0 : [taux, assiette, facteur].some((n) => n.nodeValue === null || n.nodeValue === 0) ? 0 : mult(assiette.nodeValue, taux.nodeValue, facteur.nodeValue, plafond.nodeValue);
  let unit = inferUnit("*", [assiette, taux, facteur].map((el) => el.unit));
  if (areUnitConvertible(unit, assiette.unit)) {
    nodeValue = convertUnit(unit, assiette.unit, nodeValue);
    unit = assiette.unit;
  }
  return simplifyNodeUnit(__spreadProps(__spreadValues({}, node), {
    missingVariables: mergeAllMissing([assiette, taux, facteur, plafond]),
    nodeValue,
    unit,
    explanation: {
      assiette,
      taux,
      facteur,
      plafond,
      plafondActif: assiette.nodeValue > plafond.nodeValue
    }
  }));
};
registerEvaluationFunction("produit", evaluateProduit);

// source/ruleUtils.ts
var ruleUtils_exports = {};
__export(ruleUtils_exports, {
  cyclicDependencies: () => cyclicDependencies,
  decodeRuleName: () => decodeRuleName,
  disambiguateRuleReference: () => disambiguateRuleReference,
  encodeRuleName: () => encodeRuleName,
  nameLeaf: () => nameLeaf,
  ruleParents: () => ruleParents,
  ruleWithDedicatedDocumentationPage: () => ruleWithDedicatedDocumentationPage
});

// source/parsePublicodes.ts
var import_yaml = __toESM(require("yaml"), 1);

// source/AST/index.ts
function makeASTTransformer(fn) {
  function transform(node) {
    const updatedNode = fn(node, transform);
    if (updatedNode === false) {
      return node;
    }
    if (updatedNode === void 0) {
      return traverseASTNode(transform, node);
    }
    return updatedNode;
  }
  return transform;
}
function reduceAST(fn, start, node) {
  function traverseFn(acc, node2) {
    const result = fn(acc, node2, traverseFn.bind(null, start));
    if (result === void 0) {
      return getChildrenNodes(node2).reduce(traverseFn, acc);
    }
    return result;
  }
  return traverseFn(start, node);
}
function getChildrenNodes(node) {
  const nodes = [];
  traverseASTNode((node2) => {
    nodes.push(node2);
    return node2;
  }, node);
  return nodes;
}
function traverseParsedRules(fn, parsedRules) {
  return Object.fromEntries(Object.entries(parsedRules).map(([name, rule]) => [name, fn(rule)]));
}
var traverseASTNode = (fn, node) => {
  switch (node.nodeKind) {
    case "rule":
      return traverseRuleNode(fn, node);
    case "reference":
    case "constant":
      return traverseLeafNode(fn, node);
    case "applicable si":
    case "non applicable si":
      return traverseApplicableNode(fn, node);
    case "arrondi":
      return traverseArrondiNode(fn, node);
    case "bar\xE8me":
    case "taux progressif":
    case "grille":
      return traverseNodeWithTranches(fn, node);
    case "somme":
    case "une de ces conditions":
    case "une possibilit\xE9":
    case "toutes ces conditions":
    case "minimum":
    case "maximum":
      return traverseArrayNode(fn, node);
    case "dur\xE9e":
      return traverseDur\u00E9eNode(fn, node);
    case "r\xE9soudre r\xE9f\xE9rence circulaire":
      return traverseR\u00E9soudreR\u00E9f\u00E9renceCirculaireNode(fn, node);
    case "inversion":
      return traverseInversionNode(fn, node);
    case "operation":
      return traverseOperationNode(fn, node);
    case "par d\xE9faut":
      return traverseParD\u00E9fautNode(fn, node);
    case "plancher":
      return traversePlancherNode(fn, node);
    case "plafond":
      return traversePlafondNode(fn, node);
    case "produit":
      return traverseProductNode(fn, node);
    case "recalcul":
      return traverseRecalculNode(fn, node);
    case "abattement":
      return traverseAbattementNode(fn, node);
    case "nom dans la situation":
      return traverseSituationNode(fn, node);
    case "synchronisation":
      return traverseSynchronisationNode(fn, node);
    case "unit\xE9":
      return traverseUnit\u00E9Node(fn, node);
    case "variations":
      return traverseVariationNode(fn, node);
    case "replacementRule":
      return traverseReplacementNode(fn, node);
    case "texte":
      return traverseTextNode(fn, node);
    default:
      neverHappens(node);
      throw new InternalError(node);
  }
};
var traverseRuleNode = (fn, node) => __spreadProps(__spreadValues({}, node), {
  replacements: node.replacements.map(fn),
  suggestions: Object.fromEntries(Object.entries(node.suggestions).map(([key, value]) => [key, fn(value)])),
  explanation: {
    parents: node.explanation.parents.map(fn),
    valeur: fn(node.explanation.valeur)
  }
});
var traverseReplacementNode = (fn, node) => __spreadProps(__spreadValues({}, node), {
  definitionRule: fn(node.definitionRule),
  replacedReference: fn(node.replacedReference),
  replacementNode: fn(node.replacementNode),
  whiteListedNames: node.whiteListedNames.map(fn),
  blackListedNames: node.blackListedNames.map(fn)
});
var traverseLeafNode = (_, node) => node;
var traverseApplicableNode = (fn, node) => __spreadProps(__spreadValues({}, node), {
  explanation: {
    condition: fn(node.explanation.condition),
    valeur: fn(node.explanation.valeur)
  }
});
function traverseTranche(fn, tranches) {
  return tranches.map((tranche) => __spreadValues(__spreadValues(__spreadValues(__spreadValues({}, tranche), tranche.plafond && { plafond: fn(tranche.plafond) }), "montant" in tranche && { montant: fn(tranche.montant) }), "taux" in tranche && { taux: fn(tranche.taux) }));
}
var traverseNodeWithTranches = (fn, node) => __spreadProps(__spreadValues({}, node), {
  explanation: {
    assiette: fn(node.explanation.assiette),
    multiplicateur: fn(node.explanation.multiplicateur),
    tranches: traverseTranche(fn, node.explanation.tranches)
  }
});
var traverseArrayNode = (fn, node) => __spreadProps(__spreadValues({}, node), {
  explanation: node.explanation.map(fn)
});
var traverseOperationNode = (fn, node) => __spreadProps(__spreadValues({}, node), {
  explanation: [fn(node.explanation[0]), fn(node.explanation[1])]
});
var traverseDur\u00E9eNode = (fn, node) => __spreadProps(__spreadValues({}, node), {
  explanation: {
    depuis: fn(node.explanation.depuis),
    "jusqu'\xE0": fn(node.explanation["jusqu'\xE0"])
  }
});
var traverseInversionNode = (fn, node) => __spreadProps(__spreadValues({}, node), {
  explanation: __spreadProps(__spreadValues({}, node.explanation), {
    inversionCandidates: node.explanation.inversionCandidates.map(fn)
  })
});
var traverseParD\u00E9fautNode = (fn, node) => __spreadProps(__spreadValues({}, node), {
  explanation: {
    valeur: fn(node.explanation.valeur),
    parD\u00E9faut: fn(node.explanation.parD\u00E9faut)
  }
});
var traverseArrondiNode = (fn, node) => __spreadProps(__spreadValues({}, node), {
  explanation: {
    valeur: fn(node.explanation.valeur),
    arrondi: fn(node.explanation.arrondi)
  }
});
var traversePlancherNode = (fn, node) => __spreadProps(__spreadValues({}, node), {
  explanation: {
    valeur: fn(node.explanation.valeur),
    plancher: fn(node.explanation.plancher)
  }
});
var traverseR\u00E9soudreR\u00E9f\u00E9renceCirculaireNode = (fn, node) => __spreadProps(__spreadValues({}, node), {
  explanation: __spreadProps(__spreadValues({}, node.explanation), {
    valeur: fn(node.explanation.valeur)
  })
});
var traversePlafondNode = (fn, node) => __spreadProps(__spreadValues({}, node), {
  explanation: {
    valeur: fn(node.explanation.valeur),
    plafond: fn(node.explanation.plafond)
  }
});
var traverseProductNode = (fn, node) => __spreadProps(__spreadValues({}, node), {
  explanation: {
    assiette: fn(node.explanation.assiette),
    taux: fn(node.explanation.taux),
    facteur: fn(node.explanation.facteur),
    plafond: fn(node.explanation.plafond)
  }
});
var traverseTextNode = (fn, node) => __spreadProps(__spreadValues({}, node), {
  explanation: node.explanation.map((element) => typeof element === "string" ? element : fn(element))
});
var traverseRecalculNode = (fn, node) => __spreadProps(__spreadValues({}, node), {
  explanation: __spreadProps(__spreadValues({}, node.explanation), {
    amendedSituation: node.explanation.amendedSituation.map(([name, value]) => [
      fn(name),
      fn(value)
    ]),
    recalcul: node.explanation.recalcul && fn(node.explanation.recalcul)
  })
});
var traverseAbattementNode = (fn, node) => __spreadProps(__spreadValues({}, node), {
  explanation: {
    assiette: fn(node.explanation.assiette),
    abattement: fn(node.explanation.abattement)
  }
});
var traverseSituationNode = (fn, node) => __spreadProps(__spreadValues({}, node), {
  explanation: __spreadProps(__spreadValues(__spreadValues({}, node.explanation), node.explanation.situationValeur && {
    situationValeur: fn(node.explanation.situationValeur)
  }), {
    valeur: fn(node.explanation.valeur)
  })
});
var traverseSynchronisationNode = (fn, node) => __spreadProps(__spreadValues({}, node), {
  explanation: __spreadProps(__spreadValues({}, node.explanation), {
    data: fn(node.explanation.data)
  })
});
var traverseUnit\u00E9Node = (fn, node) => __spreadProps(__spreadValues({}, node), {
  explanation: fn(node.explanation)
});
var traverseVariationNode = (fn, node) => __spreadProps(__spreadValues({}, node), {
  explanation: node.explanation.map(({ condition, consequence }) => ({
    condition: fn(condition),
    consequence: fn(consequence)
  }))
});

// source/replacement.tsx
var remplacementRuleId = 0;
var cache = {};
function parseReplacements(replacements, context) {
  if (!replacements) {
    return [];
  }
  const markReferenceAsCircularContext = __spreadProps(__spreadValues({}, context), {
    circularReferences: true
  });
  return (Array.isArray(replacements) ? replacements : [replacements]).map((replacement) => {
    var _a, _b, _c;
    if (typeof replacement === "string") {
      replacement = { r\u00E8gle: replacement };
    }
    const replacedReference = parse(replacement.r\u00E8gle, markReferenceAsCircularContext);
    const replacementNode = parse((_a = replacement.par) != null ? _a : context.dottedName, markReferenceAsCircularContext);
    const [whiteListedNames, blackListedNames] = [
      (_b = replacement.dans) != null ? _b : [],
      (_c = replacement["sauf dans"]) != null ? _c : []
    ].map((dottedName) => Array.isArray(dottedName) ? dottedName : [dottedName]).map((refs) => refs.map((ref) => parse(ref, markReferenceAsCircularContext)));
    return {
      nodeKind: "replacementRule",
      rawNode: replacement,
      definitionRule: parse(context.dottedName, markReferenceAsCircularContext),
      replacedReference,
      replacementNode,
      whiteListedNames,
      blackListedNames,
      remplacementRuleId: remplacementRuleId++
    };
  });
}
function parseRendNonApplicable(rules, context) {
  return parseReplacements(rules, context).map((replacement) => __spreadProps(__spreadValues({}, replacement), {
    replacementNode: defaultNode(null)
  }));
}
function getReplacements(parsedRules) {
  return Object.values(parsedRules).flatMap((rule) => rule.replacements).reduce((acc, r) => {
    var _a;
    if (!r.replacedReference.dottedName) {
      throw new InternalError(r);
    }
    const key = r.replacedReference.dottedName;
    return __spreadProps(__spreadValues({}, acc), { [key]: [...(_a = acc[key]) != null ? _a : [], r] });
  }, {});
}
function inlineReplacements(replacements, logger) {
  return makeASTTransformer((node, transform) => {
    var _a;
    if (node.nodeKind === "replacementRule" || node.nodeKind === "inversion" || node.nodeKind === "une possibilit\xE9") {
      return false;
    }
    if (node.nodeKind === "recalcul") {
      return __spreadProps(__spreadValues({}, node), {
        explanation: __spreadProps(__spreadValues({}, node.explanation), {
          recalcul: node.explanation.recalcul && transform(node.explanation.recalcul),
          amendedSituation: node.explanation.amendedSituation.map(([name, value]) => [name, transform(value)])
        })
      });
    }
    if (node.nodeKind === "reference") {
      if (!node.dottedName) {
        throw new InternalError(node);
      }
      return replace(node, (_a = replacements[node.dottedName]) != null ? _a : [], logger);
    }
  });
}
function replace(node, replacements, logger) {
  var _a;
  const applicableReplacements = replacements.filter(({ definitionRule }) => definitionRule.dottedName !== node.contextDottedName).filter(({ whiteListedNames }) => !whiteListedNames.length || whiteListedNames.some((name) => node.contextDottedName.startsWith(name.dottedName))).filter(({ blackListedNames }) => !blackListedNames.length || blackListedNames.every((name) => !node.contextDottedName.startsWith(name.dottedName))).sort((r1, r2) => {
    const criterion1 = +!!r2.whiteListedNames.length - +!!r1.whiteListedNames.length;
    const criterion2 = +!!r2.blackListedNames.length - +!!r1.blackListedNames.length;
    return criterion1 || criterion2;
  });
  if (!applicableReplacements.length) {
    return node;
  }
  if (applicableReplacements.length > 1) {
    const displayVerboseWarning = false;
    if (displayVerboseWarning) {
      warning(logger, node.contextDottedName, `
				Il existe plusieurs remplacements pour la r\xE9f\xE9rence '${node.dottedName}'.
				Lors de l'execution, ils seront r\xE9solus dans l'odre suivant :
				${applicableReplacements.map((replacement) => `
	- Celui d\xE9finit dans la r\xE8gle '${replacement.definitionRule.dottedName}'`)}
					`);
    }
  }
  const applicableReplacementsCacheKey = applicableReplacements.map((n) => n.remplacementRuleId).join("-");
  (_a = cache[applicableReplacementsCacheKey]) != null ? _a : cache[applicableReplacementsCacheKey] = {
    nodeKind: "variations",
    visualisationKind: "replacement",
    rawNode: node.rawNode,
    explanation: [
      ...applicableReplacements.map((replacement) => ({
        condition: replacement.definitionRule,
        consequence: replacement.replacementNode
      })),
      {
        condition: defaultNode(true),
        consequence: node
      }
    ]
  };
  return cache[applicableReplacementsCacheKey];
}

// source/parsePublicodes.ts
function parsePublicodes2(rawRules, partialContext = {}) {
  var _a, _b, _c, _d;
  let rules = typeof rawRules === "string" ? import_yaml.default.parse(("" + rawRules).replace(/\t/g, "  ")) : __spreadValues({}, rawRules);
  rules = transpileRef(rules);
  const context = {
    dottedName: (_a = partialContext.dottedName) != null ? _a : "",
    parsedRules: (_b = partialContext.parsedRules) != null ? _b : {},
    logger: (_c = partialContext.logger) != null ? _c : console,
    getUnitKey: (_d = partialContext.getUnitKey) != null ? _d : (x) => x,
    circularReferences: false
  };
  Object.entries(rules).forEach(([dottedName, rule]) => {
    if (typeof rule === "string" || typeof rule === "number") {
      rule = {
        formule: `${rule}`
      };
    }
    if (typeof rule !== "object") {
      throw new SyntaxError(`Rule ${dottedName} is incorrectly written. Please give it a proper value.`);
    }
    parse(__spreadValues({ nom: dottedName }, rule), context);
  });
  let parsedRules = context.parsedRules;
  const rulesDependencies = {};
  parsedRules = traverseParsedRules(disambiguateReferenceAndCollectDependencies(parsedRules, rulesDependencies), parsedRules);
  const replacements = getReplacements(parsedRules);
  parsedRules = traverseParsedRules(inlineReplacements(replacements, context.logger), parsedRules);
  const ruleUnits = inferRulesUnit(parsedRules, rulesDependencies);
  return { parsedRules, ruleUnits, rulesDependencies };
}
function transpileRef(object) {
  if (Array.isArray(object)) {
    return object.map(transpileRef);
  }
  if (!object || typeof object !== "object") {
    return object;
  }
  return Object.entries(object).reduce((obj, [key, value]) => {
    var _a;
    const match = /\[ref( (.+))?\]$/.exec(key);
    if (!match) {
      return __spreadProps(__spreadValues({}, obj), { [key]: transpileRef(value) });
    }
    const argumentType = key.replace(match[0], "").trim();
    const argumentName = ((_a = match[2]) == null ? void 0 : _a.trim()) || argumentType;
    return __spreadProps(__spreadValues({}, obj), {
      [argumentType]: {
        nom: argumentName,
        valeur: transpileRef(value)
      }
    });
  }, {});
}
var disambiguateReferenceAndCollectDependencies = (parsedRules, dependencies) => makeASTTransformer((node) => {
  var _a, _b;
  if (node.nodeKind === "reference") {
    const dottedName = disambiguateRuleReference(parsedRules, node.contextDottedName, node.name);
    if (!((_a = node.circularReference) != null ? _a : false)) {
      dependencies[node.contextDottedName] = [
        ...(_b = dependencies[node.contextDottedName]) != null ? _b : [],
        dottedName
      ];
    }
    return __spreadProps(__spreadValues({}, node), {
      dottedName,
      title: parsedRules[dottedName].title,
      acronym: parsedRules[dottedName].rawNode.acronyme
    });
  }
});
function topologicalSort(rulesNames, dependencyGraph) {
  const result = [];
  const temp = {};
  for (const ruleName of rulesNames) {
    if (!result.includes(ruleName)) {
      topologicalSortHelper(ruleName);
    }
  }
  function topologicalSortHelper(ruleName) {
    var _a;
    temp[ruleName] = true;
    const nodeDependencies = (_a = dependencyGraph[ruleName]) != null ? _a : [];
    for (const dependency of nodeDependencies) {
      if (temp[dependency]) {
        continue;
      }
      if (!result.includes(dependency)) {
        topologicalSortHelper(dependency);
      }
    }
    temp[ruleName] = false;
    result.push(ruleName);
  }
  return result;
}
function inferRulesUnit(parsedRules, rulesDependencies) {
  const topologicalOrder = topologicalSort(Object.keys(parsedRules), rulesDependencies);
  const cache2 = /* @__PURE__ */ new WeakMap();
  topologicalOrder.forEach((ruleName) => {
    inferNodeUnitAndCache(parsedRules[ruleName]);
  });
  topologicalOrder.forEach((ruleName) => {
    if (parsedRules[ruleName].nodeKind === "rule") {
      parsedRules[ruleName].explanation.parents.forEach((parent) => {
        inferNodeUnitAndCache(parent);
      });
    }
  });
  function inferNodeUnitAndCache(node) {
    if (cache2.has(node)) {
      return cache2.get(node);
    }
    const unit = inferNodeType(node);
    cache2.set(node, unit);
    return unit;
  }
  function inferNodeType(node) {
    switch (node.nodeKind) {
      case "somme":
      case "produit":
      case "bar\xE8me":
      case "dur\xE9e":
      case "grille":
      case "taux progressif":
      case "maximum":
      case "minimum":
        return { isNullable: false };
      case "applicable si":
      case "non applicable si":
        return { isNullable: true };
      case "toutes ces conditions":
      case "une de ces conditions":
        return { isNullable: true };
      case "constant":
        return {
          isNullable: node.nodeValue === null || typeof node.nodeValue === "boolean"
        };
      case "operation":
        return {
          isNullable: ["<", "<=", ">", ">=", "=", "!="].includes(node.operationKind)
        };
      case "inversion":
      case "recalcul":
      case "replacementRule":
      case "une possibilit\xE9":
      case "r\xE9soudre r\xE9f\xE9rence circulaire":
      case "synchronisation":
      case "texte":
        return { isNullable: false };
      case "abattement":
        return inferNodeUnitAndCache(node.explanation.assiette);
      case "arrondi":
      case "nom dans la situation":
      case "plafond":
      case "plancher":
      case "rule":
        return inferNodeUnitAndCache(node.explanation.valeur);
      case "unit\xE9":
        return inferNodeUnitAndCache(node.explanation);
      case "variations":
        return {
          isNullable: node.explanation.some((line) => {
            if (inferNodeUnitAndCache(line.consequence) === void 0) {
              return false;
            }
            return inferNodeUnitAndCache(line.consequence).isNullable;
          })
        };
      case "par d\xE9faut":
        return {
          isNullable: inferNodeUnitAndCache(node.explanation.parD\u00E9faut).isNullable || inferNodeUnitAndCache(node.explanation.valeur).isNullable
        };
      case "reference":
        return cache2.get(parsedRules[node.dottedName]);
    }
  }
  return cache2;
}

// source/AST/findCycles.ts
function has(obj, key) {
  return obj != null && Object.prototype.hasOwnProperty.call(obj, key);
}
function constant(value) {
  return function(...args) {
    return value;
  };
}
var DEFAULT_EDGE_NAME = "\0";
var EDGE_KEY_DELIM = "";
var incrementOrInitEntry = (map, k) => {
  if (map[k]) {
    map[k]++;
  } else {
    map[k] = 1;
  }
};
var decrementOrRemoveEntry = (map, k) => {
  if (!--map[k]) {
    delete map[k];
  }
};
var edgeArgsToId = (isDirected, v_, w_, name) => {
  let v = "" + v_;
  let w = "" + w_;
  if (!isDirected && v > w) {
    const tmp = v;
    v = w;
    w = tmp;
  }
  return v + EDGE_KEY_DELIM + w + EDGE_KEY_DELIM + (name === void 0 ? DEFAULT_EDGE_NAME : name);
};
var edgeArgsToObj = (isDirected, v_, w_, name) => {
  let v = "" + v_;
  let w = "" + w_;
  if (!isDirected && v > w) {
    const tmp = v;
    v = w;
    w = tmp;
  }
  const edgeObj = { v, w };
  if (name) {
    edgeObj.name = name;
  }
  return edgeObj;
};
var edgeObjToId = (isDirected, edgeObj) => {
  return edgeArgsToId(isDirected, edgeObj.v, edgeObj.w, edgeObj.name);
};
var Graph = class {
  _nodeCount = 0;
  _edgeCount = 0;
  _isDirected;
  _label;
  _defaultNodeLabelFn;
  _defaultEdgeLabelFn;
  _nodes;
  _in;
  _preds;
  _out;
  _sucs;
  _edgeObjs;
  _edgeLabels;
  constructor(opts = {}) {
    this._isDirected = has(opts, "directed") ? opts.directed : true;
    this._label = void 0;
    this._defaultNodeLabelFn = constant(void 0);
    this._defaultEdgeLabelFn = constant(void 0);
    this._nodes = {};
    this._in = {};
    this._preds = {};
    this._out = {};
    this._sucs = {};
    this._edgeObjs = {};
    this._edgeLabels = {};
  }
  isDirected() {
    return this._isDirected;
  }
  setGraph(label) {
    this._label = label;
    return this;
  }
  graph() {
    return this._label;
  }
  nodeCount() {
    return this._nodeCount;
  }
  nodes() {
    return Object.keys(this._nodes);
  }
  setNode(v, value = void 0) {
    if (has(this._nodes, v)) {
      if (arguments.length > 1) {
        this._nodes[v] = value;
      }
      return this;
    }
    this._nodes[v] = arguments.length > 1 ? value : this._defaultNodeLabelFn(v);
    this._in[v] = {};
    this._preds[v] = {};
    this._out[v] = {};
    this._sucs[v] = {};
    ++this._nodeCount;
    return this;
  }
  setNodes(vs, value) {
    vs.forEach((v) => {
      if (value !== void 0) {
        this.setNode(v, value);
      } else {
        this.setNode(v);
      }
    });
    return this;
  }
  node(v) {
    return this._nodes[v];
  }
  hasNode(v) {
    return has(this._nodes, v);
  }
  successors(v) {
    const sucsV = this._sucs[v];
    if (sucsV) {
      return Object.keys(sucsV);
    }
  }
  edgeCount() {
    return this._edgeCount;
  }
  edges() {
    return Object.values(this._edgeObjs);
  }
  setEdge(v, w, value = void 0, name = void 0) {
    v = "" + v;
    w = "" + w;
    const e = edgeArgsToId(this._isDirected, v, w, name);
    if (has(this._edgeLabels, e)) {
      if (value !== void 0) {
        this._edgeLabels[e] = value;
      }
      return this;
    }
    this.setNode(v);
    this.setNode(w);
    this._edgeLabels[e] = value !== void 0 ? value : this._defaultEdgeLabelFn(v, w, name);
    const edgeObj = edgeArgsToObj(this._isDirected, v, w, name);
    v = edgeObj.v;
    w = edgeObj.w;
    Object.freeze(edgeObj);
    this._edgeObjs[e] = edgeObj;
    incrementOrInitEntry(this._preds[w], v);
    incrementOrInitEntry(this._sucs[v], w);
    this._in[w][e] = edgeObj;
    this._out[v][e] = edgeObj;
    this._edgeCount++;
    return this;
  }
  edge(v, w, name) {
    const e = arguments.length === 1 ? edgeObjToId(this._isDirected, arguments[0]) : edgeArgsToId(this._isDirected, v, w, name);
    return this._edgeLabels[e];
  }
  hasEdge(v, w, name) {
    const e = arguments.length === 1 ? edgeObjToId(this._isDirected, arguments[0]) : edgeArgsToId(this._isDirected, v, w, name);
    return has(this._edgeLabels, e);
  }
  removeEdge(v, w, name) {
    const e = arguments.length === 1 ? edgeObjToId(this._isDirected, arguments[0]) : edgeArgsToId(this._isDirected, v, w, name);
    const edge = this._edgeObjs[e];
    if (edge) {
      v = edge.v;
      w = edge.w;
      delete this._edgeLabels[e];
      delete this._edgeObjs[e];
      decrementOrRemoveEntry(this._preds[w], v);
      decrementOrRemoveEntry(this._sucs[v], w);
      delete this._in[w][e];
      delete this._out[v][e];
      this._edgeCount--;
    }
    return this;
  }
  outEdges(v, w = void 0) {
    const outV = this._out[v];
    if (outV) {
      const edges = Object.values(outV);
      if (w === void 0) {
        return edges;
      }
      return edges.filter(function(edge) {
        return edge.w === w;
      });
    }
  }
};
function tarjan(graph) {
  let index = 0;
  const stack = [];
  const visited = {};
  const results = [];
  function dfs(v) {
    const entry = visited[v] = {
      onStack: true,
      lowlink: index,
      index: index++
    };
    stack.push(v);
    graph.successors(v).forEach(function(w) {
      if (!Object.prototype.hasOwnProperty.call(visited, w)) {
        dfs(w);
        entry.lowlink = Math.min(entry.lowlink, visited[w].lowlink);
      } else if (visited[w].onStack) {
        entry.lowlink = Math.min(entry.lowlink, visited[w].index);
      }
    });
    if (entry.lowlink === entry.index) {
      const cmpt = [];
      let w;
      do {
        w = stack.pop();
        visited[w].onStack = false;
        cmpt.push(w);
      } while (v !== w);
      results.push(cmpt);
    }
  }
  graph.nodes().forEach(function(v) {
    if (!Object.prototype.hasOwnProperty.call(visited, v)) {
      dfs(v);
    }
  });
  return results;
}
function findCycles(graph) {
  return tarjan(graph).filter(function(cmpt) {
    return cmpt.length > 1 || cmpt.length === 1 && graph.hasEdge(cmpt[0], cmpt[0]);
  });
}

// source/AST/graph.ts
function buildDependenciesGraph(rulesDeps) {
  const g = new Graph();
  Object.entries(rulesDeps).forEach(([ruleDottedName, dependencies]) => {
    dependencies.forEach((depDottedName) => {
      g.setEdge(ruleDottedName, depDottedName);
    });
  });
  return g;
}
function squashCycle(rulesDependenciesObject, cycle) {
  function* loopFrom(i) {
    let j = i;
    while (true) {
      yield cycle[j++ % cycle.length];
    }
  }
  const smallCycleStartingAt = [];
  for (let i = 0; i < cycle.length; i++) {
    const smallCycle = [];
    let previousVertex = void 0;
    for (const vertex of loopFrom(i)) {
      if (previousVertex === void 0) {
        smallCycle.push(vertex);
        previousVertex = vertex;
      } else if (rulesDependenciesObject[previousVertex].includes(vertex)) {
        if (smallCycle.includes(vertex)) {
          smallCycle.splice(0, smallCycle.lastIndexOf(vertex));
          break;
        }
        smallCycle.push(vertex);
        previousVertex = vertex;
      }
    }
    smallCycleStartingAt.push(smallCycle);
  }
  const smallest = smallCycleStartingAt.reduce((minCycle, someCycle) => someCycle.length > minCycle.length ? minCycle : someCycle);
  return smallest;
}
function cyclicDependencies(rawRules) {
  const { rulesDependencies } = parsePublicodes2(rawRules);
  const dependenciesGraph = buildDependenciesGraph(rulesDependencies);
  const cycles = findCycles(dependenciesGraph);
  const reversedCycles = cycles.map((c) => c.reverse());
  const smallCycles = reversedCycles.map((cycle) => squashCycle(rulesDependencies, cycle));
  const printableStronglyConnectedComponents = reversedCycles.map((c, i) => printInDotFormat(dependenciesGraph, c, smallCycles[i]));
  return [smallCycles, printableStronglyConnectedComponents];
}
var edgeIsInCycle = (cycle, v, w) => {
  for (let i = 0; i < cycle.length + 1; i++) {
    if (v === cycle[i] && w === cycle[(i + 1) % cycle.length])
      return true;
  }
  return false;
};
function printInDotFormat(dependenciesGraph, cycle, subCycleToHighlight) {
  const edgesSet = /* @__PURE__ */ new Set();
  cycle.forEach((vertex) => {
    dependenciesGraph.outEdges(vertex).filter(({ w }) => cycle.includes(w)).forEach(({ v, w }) => {
      edgesSet.add(`"${v}" -> "${w}"` + (edgeIsInCycle(subCycleToHighlight, v, w) ? " [color=red]" : ""));
    });
  });
  return `digraph Cycle {
	${[...edgesSet].join(";\n	")};
}`;
}

// source/ruleUtils.ts
var splitName = (str) => str.split(" . ");
var joinName = (strs) => strs.join(" . ");
var nameLeaf = (name) => {
  var _a;
  return (_a = splitName(name).slice(-1)) == null ? void 0 : _a[0];
};
var encodeRuleName = (name) => name == null ? void 0 : name.replace(/\s\.\s/g, "/").replace(/-/g, "\u2011").replace(/\s/g, "-");
var decodeRuleName = (name) => name.replace(/\//g, " . ").replace(/-/g, " ").replace(/\u2011/g, "-");
function ruleParents(dottedName) {
  const fragments = splitName(dottedName);
  return Array(fragments.length - 1).fill(0).map((f, i) => fragments.slice(0, i + 1)).map(joinName).reverse();
}
function disambiguateRuleReference(rules, contextName = "", partialName) {
  const possibleDottedName = [contextName, ...ruleParents(contextName), ""].map((x) => x ? x + " . " + partialName : partialName).sort((a, b) => a === contextName ? 1 : b === contextName ? -1 : 0);
  const dottedName = possibleDottedName.find((name) => name in rules);
  if (!dottedName) {
    syntaxError(contextName, `La r\xE9f\xE9rence '${partialName}' est introuvable.
	V\xE9rifiez que l'orthographe et l'espace de nom sont corrects`);
    throw new Error();
  }
  return dottedName;
}
function ruleWithDedicatedDocumentationPage(rule) {
  return rule.virtualRule !== true && rule.type !== "groupe" && rule.type !== "texte" && rule.type !== "paragraphe" && rule.type !== "notification";
}

// source/mecanisms/recalcul.ts
var evaluateRecalcul = function(node) {
  var _a;
  if (this.cache._meta.currentRecalcul) {
    if (node.explanation.recalcul && this.cache._meta.currentRecalcul !== node.explanation.recalcul) {
      warning(this.options.logger, this.cache._meta.evaluationRuleStack[0], `Un recalcul imbriqu\xE9 a \xE9t\xE9 tent\xE9 \xE0 l'int\xE9rieur du recalcul ${this.cache._meta.currentRecalcul}. La valeur undefined (non d\xE9fini) est retourn\xE9e.`);
    }
    return defaultNode(void 0);
  }
  const amendedSituation = node.explanation.amendedSituation.map(([originRule, replacement]) => [
    this.evaluate(originRule),
    this.evaluate(replacement)
  ]).filter(([originRule, replacement]) => originRule.nodeValue !== replacement.nodeValue || serializeUnit(originRule.unit) !== serializeUnit(replacement.unit));
  const engine = amendedSituation.length ? this.shallowCopy().setSituation(__spreadValues(__spreadValues({}, this.parsedSituation), Object.fromEntries(amendedSituation.map(([reference, replacement]) => [
    disambiguateRuleReference(this.parsedRules, reference.contextDottedName, reference.name),
    replacement
  ])))) : this;
  const nodeToEvaluate = (_a = node.explanation.recalcul) != null ? _a : this.getRule(node.explanation.contextDottedName);
  engine.cache._meta.currentRecalcul = nodeToEvaluate;
  const evaluatedNode = engine.evaluate(nodeToEvaluate);
  delete engine.cache._meta.currentRecalcul;
  return __spreadValues(__spreadProps(__spreadValues({}, node), {
    nodeValue: evaluatedNode.nodeValue,
    explanation: __spreadProps(__spreadValues({}, node.explanation), {
      recalcul: evaluatedNode,
      amendedSituation,
      parsedSituation: engine.parsedSituation,
      subEngineId: engine.subEngineId
    }),
    missingVariables: evaluatedNode.missingVariables
  }), "unit" in evaluatedNode && { unit: evaluatedNode.unit });
};
var mecanismRecalcul = (v, context) => {
  const amendedSituation = Object.keys(v.avec).map((dottedName) => [
    parse(dottedName, context),
    parse(v.avec[dottedName], context)
  ]);
  const recalculNode = v.r\u00E8gle && parse(v.r\u00E8gle, __spreadProps(__spreadValues({}, context), { circularReferences: true }));
  return {
    explanation: {
      recalcul: recalculNode,
      contextDottedName: context.dottedName,
      amendedSituation
    },
    nodeKind: "recalcul"
  };
};
registerEvaluationFunction("recalcul", evaluateRecalcul);

// source/mecanisms/résoudre-référence-circulaire.ts
var evaluateR\u00E9soudreR\u00E9f\u00E9renceCirculaire = function(node) {
  const originalCache = this.cache;
  let inversionNumberOfIterations = 0;
  const evaluateWithValue = (n, unit2 = { numerators: [], denominators: [] }) => {
    inversionNumberOfIterations++;
    this.resetCache();
    this.parsedSituation[node.explanation.ruleToSolve] = {
      unit: unit2,
      nodeKind: "unit\xE9",
      explanation: {
        nodeKind: "constant",
        nodeValue: n,
        type: "number"
      }
    };
    return this.evaluate(node.explanation.valeur);
  };
  const inversionFailed = Symbol("inversion failed");
  let nodeValue = inversionFailed;
  const x0 = 0;
  let valeur = evaluateWithValue(x0);
  const y0 = valeur.nodeValue;
  const unit = valeur.unit;
  const missingVariables = valeur.missingVariables;
  let i = 0;
  if (y0 !== void 0) {
    const test = (x) => {
      if (x === x0) {
        return y0 - x0;
      }
      valeur = evaluateWithValue(x, unit);
      const y = valeur.nodeValue;
      i++;
      return y - x;
    };
    const defaultMin = -1e6;
    const defaultMax = 1e8;
    nodeValue = uniroot(test, defaultMin, defaultMax, 0.5, 30, 2);
  }
  this.cache = originalCache;
  if (nodeValue === inversionFailed) {
    nodeValue = void 0;
    this.cache._meta.inversionFail = true;
  }
  if (nodeValue !== void 0) {
    valeur = evaluateWithValue(nodeValue, unit);
  }
  delete this.parsedSituation[node.explanation.ruleToSolve];
  return __spreadProps(__spreadValues({}, node), {
    unit,
    nodeValue,
    explanation: __spreadProps(__spreadValues({}, node.explanation), {
      valeur,
      inversionNumberOfIterations
    }),
    missingVariables
  });
};
function parseR\u00E9soudreR\u00E9f\u00E9renceCirculaire(v, context) {
  return {
    explanation: {
      ruleToSolve: context.dottedName,
      valeur: parse(v.valeur, __spreadProps(__spreadValues({}, context), { circularReferences: true }))
    },
    nodeKind: "r\xE9soudre r\xE9f\xE9rence circulaire"
  };
}
parseR\u00E9soudreR\u00E9f\u00E9renceCirculaire.nom = "r\xE9soudre la r\xE9f\xE9rence circulaire";
registerEvaluationFunction("r\xE9soudre r\xE9f\xE9rence circulaire", evaluateR\u00E9soudreR\u00E9f\u00E9renceCirculaire);

// source/AST/types.ts
function isNotYetDefined(value) {
  return value === void 0;
}
function isNotApplicable(value) {
  return value === null;
}

// source/mecanisms/situation.ts
function parseSituation(v, context) {
  const explanation = {
    situationKey: v[parseSituation.nom],
    valeur: parse(v.valeur, context)
  };
  return {
    nodeKind: parseSituation.nom,
    explanation
  };
}
parseSituation.nom = "nom dans la situation";
registerEvaluationFunction(parseSituation.nom, function evaluate16(node) {
  var _a;
  const explanation = __spreadValues({}, node.explanation);
  const situationKey = explanation.situationKey;
  let valeur;
  if (situationKey in this.parsedSituation) {
    valeur = this.evaluate(this.parsedSituation[situationKey]);
    explanation.situationValeur = valeur;
  } else {
    valeur = this.evaluate(explanation.valeur);
    explanation.valeur = valeur;
    delete explanation.situationValeur;
  }
  const unit = (_a = valeur.unit) != null ? _a : "unit" in explanation.valeur ? explanation.valeur.unit : void 0;
  const missingVariables = mergeAllMissing([explanation.situationValeur, explanation.valeur].filter(Boolean));
  return __spreadProps(__spreadValues(__spreadProps(__spreadValues({}, node), {
    nodeValue: valeur.nodeValue,
    missingVariables: Object.keys(missingVariables).length === 0 && isNotYetDefined(valeur.nodeValue) ? { [situationKey]: 1 } : missingVariables
  }), unit !== void 0 && { unit }), {
    explanation
  });
});

// source/mecanisms/sum.tsx
var evaluate17 = evaluateArray((x, y) => x + y, 0);
var mecanismSum = (v, context) => {
  const explanation = v.map((node) => parse(node, context));
  return {
    explanation,
    nodeKind: "somme"
  };
};
registerEvaluationFunction("somme", evaluate17);

// source/mecanisms/synchronisation.ts
var evaluate18 = function(node) {
  var _a;
  const data = this.evaluate(node.explanation.data);
  const valuePath = node.explanation.chemin.split(" . ");
  const path = (obj) => valuePath.reduce((res, prop) => res == null ? void 0 : res[prop], obj);
  const nodeValue = (_a = path(data.nodeValue)) != null ? _a : void 0;
  const missingVariables = __spreadValues(__spreadValues({}, data.missingVariables), data.nodeValue === void 0 ? { [data.dottedName]: 1 } : {});
  const explanation = __spreadProps(__spreadValues({}, node.explanation), { data });
  return __spreadProps(__spreadValues({}, node), { nodeValue, explanation, missingVariables });
};
var mecanismSynchronisation = (v, context) => {
  return {
    explanation: __spreadProps(__spreadValues({}, v), { data: parse(v.data, context) }),
    nodeKind: "synchronisation"
  };
};
registerEvaluationFunction("synchronisation", evaluate18);

// source/mecanisms/tauxProgressif.ts
function parseTauxProgressif(v, context) {
  const explanation = {
    assiette: parse(v.assiette, context),
    multiplicateur: v.multiplicateur ? parse(v.multiplicateur, context) : defaultNode(1),
    tranches: parseTranches(v.tranches, context)
  };
  return {
    explanation,
    nodeKind: "taux progressif"
  };
}
var evaluate19 = function(node) {
  const evaluate23 = this.evaluate.bind(this);
  const assiette = this.evaluate(node.explanation.assiette);
  const multiplicateur = this.evaluate(node.explanation.multiplicateur);
  const tranches = evaluatePlafondUntilActiveTranche.call(this, {
    parsedTranches: node.explanation.tranches,
    assiette,
    multiplicateur
  });
  const evaluatedNode = __spreadProps(__spreadValues({}, node), {
    explanation: {
      tranches,
      assiette,
      multiplicateur
    },
    unit: parseUnit("%")
  });
  const lastTranche = tranches[tranches.length - 1];
  if (tranches.every(({ isActive }) => isActive === false) || lastTranche.isActive && lastTranche.plafond.nodeValue === Infinity) {
    const taux = convertNodeToUnit(parseUnit("%"), evaluate23(lastTranche.taux));
    const { nodeValue: nodeValue2, missingVariables } = taux;
    lastTranche.taux = taux;
    lastTranche.nodeValue = nodeValue2;
    lastTranche.missingVariables = missingVariables;
    return __spreadProps(__spreadValues({}, evaluatedNode), {
      nodeValue: nodeValue2,
      missingVariables
    });
  }
  if (tranches.every(({ isActive }) => isActive !== true) || typeof assiette.nodeValue !== "number") {
    return __spreadProps(__spreadValues({}, evaluatedNode), {
      nodeValue: void 0,
      missingVariables: mergeAllMissing(tranches)
    });
  }
  const activeTrancheIndex = tranches.findIndex(({ isActive }) => isActive === true);
  const activeTranche = tranches[activeTrancheIndex];
  activeTranche.taux = convertNodeToUnit(parseUnit("%"), evaluate23(activeTranche.taux));
  const previousTranche = tranches[activeTrancheIndex - 1];
  if (previousTranche) {
    previousTranche.taux = convertNodeToUnit(parseUnit("%"), evaluate23(previousTranche.taux));
    previousTranche.isActive = true;
  }
  const previousTaux = previousTranche ? previousTranche.taux : activeTranche.taux;
  const calculationValues = [previousTaux, activeTranche.taux];
  if (calculationValues.some((n) => n.nodeValue === void 0)) {
    activeTranche.nodeValue = void 0;
    activeTranche.missingVariables = mergeAllMissing(calculationValues);
    return __spreadProps(__spreadValues({}, evaluatedNode), {
      nodeValue: void 0,
      missingVariables: activeTranche.missingVariables
    });
  }
  const lowerTaux = previousTaux.nodeValue;
  const upperTaux = activeTranche.taux.nodeValue;
  const plancher = activeTranche.plancherValue;
  const plafond = activeTranche.plafondValue;
  const coeff = (upperTaux - lowerTaux) / (plafond - plancher);
  const nodeValue = lowerTaux + (assiette.nodeValue - plancher) * coeff;
  activeTranche.nodeValue = nodeValue;
  return __spreadProps(__spreadValues({}, evaluatedNode), {
    nodeValue,
    missingVariables: {}
  });
};
registerEvaluationFunction("taux progressif", evaluate19);

// source/mecanisms/unité.ts
function parseUnit\u00E9(v, context) {
  const explanation = parse(v.valeur, context);
  const unit = parseUnit(v.unit\u00E9, context.getUnitKey);
  return {
    explanation,
    unit,
    nodeKind: parseUnit\u00E9.nom
  };
}
parseUnit\u00E9.nom = "unit\xE9";
registerEvaluationFunction(parseUnit\u00E9.nom, function evaluate20(node) {
  const valeur = this.evaluate(node.explanation);
  let nodeValue = valeur.nodeValue;
  if (nodeValue !== null && "unit" in node) {
    try {
      nodeValue = convertUnit(valeur.unit, node.unit, valeur.nodeValue);
    } catch (e) {
      warning(this.options.logger, this.cache._meta.evaluationRuleStack[0], "Erreur lors de la conversion d'unit\xE9 explicite", e);
    }
  }
  return __spreadProps(__spreadValues({}, node), {
    nodeValue,
    explanation: valeur,
    missingVariables: valeur.missingVariables
  });
});

// source/mecanisms/variations.ts
var devariate = (k, v, context) => {
  if (k === "valeur") {
    return parse(v, context);
  }
  const _a = v, { variations } = _a, factoredKeys = __objRest(_a, ["variations"]);
  const explanation = parse({
    variations: variations.map(({ alors, sinon, si }) => {
      const _a2 = alors != null ? alors : sinon, { attributs } = _a2, otherKeys = __objRest(_a2, ["attributs"]);
      return __spreadValues({
        [alors !== void 0 ? "alors" : "sinon"]: __spreadProps(__spreadValues({}, attributs), {
          [k]: __spreadValues(__spreadValues({}, factoredKeys), otherKeys)
        })
      }, si !== void 0 && { si });
    })
  }, context);
  return explanation;
};
function parseVariations(v, context) {
  const explanation = v.map(({ si, alors, sinon }) => sinon !== void 0 ? { consequence: parse(sinon, context), condition: defaultNode(true) } : { consequence: parse(alors, context), condition: parse(si, context) });
  return {
    explanation,
    nodeKind: "variations"
  };
}
var evaluate21 = function(node) {
  const [nodeValue, explanation, unit] = node.explanation.reduce(([evaluation, explanations, unit2, previousConditions], { condition, consequence }, i) => {
    if (previousConditions === true) {
      return [
        evaluation,
        [...explanations, { condition, consequence }],
        unit2,
        previousConditions
      ];
    }
    const evaluatedCondition = this.evaluate(condition);
    const currentCondition = previousConditions === void 0 ? previousConditions : !previousConditions && (evaluatedCondition.nodeValue === void 0 ? void 0 : evaluatedCondition.nodeValue !== false && evaluatedCondition.nodeValue !== null);
    evaluatedCondition.missingVariables = bonus(evaluatedCondition.missingVariables);
    if (currentCondition === false) {
      return [
        evaluation,
        [...explanations, { condition: evaluatedCondition, consequence }],
        unit2,
        previousConditions
      ];
    }
    let evaluatedConsequence = this.evaluate(consequence);
    if (unit2) {
      try {
        evaluatedConsequence = convertNodeToUnit(unit2, evaluatedConsequence);
      } catch (e) {
        warning(this.options.logger, this.cache._meta.evaluationRuleStack[0], `L'unit\xE9 de la branche n\xB0 ${i + 1} du m\xE9canisme 'variations' n'est pas compatible avec celle d'une branche pr\xE9c\xE9dente`, e);
      }
    }
    return [
      currentCondition && evaluatedConsequence.nodeValue,
      [
        ...explanations,
        {
          condition: evaluatedCondition,
          satisfied: evaluatedCondition.nodeValue !== false,
          consequence: evaluatedConsequence
        }
      ],
      unit2 || evaluatedConsequence.unit,
      previousConditions || currentCondition
    ];
  }, [null, [], void 0, false]);
  const missingVariables = mergeAllMissing(explanation.reduce((values, { condition, satisfied, consequence }) => [
    ...values,
    condition,
    ...satisfied ? [consequence] : []
  ], []));
  return __spreadProps(__spreadValues(__spreadProps(__spreadValues({}, node), {
    nodeValue
  }), unit !== void 0 && { unit }), {
    explanation,
    missingVariables
  });
};
registerEvaluationFunction("variations", evaluate21);

// source/reference.ts
function parseReference(v, context) {
  return {
    nodeKind: "reference",
    name: v,
    contextDottedName: context.dottedName,
    circularReference: context.circularReferences === true
  };
}
registerEvaluationFunction("reference", function evaluateReference(node) {
  if (!node.dottedName) {
    throw new InternalError(node);
  }
  const explanation = this.evaluate(this.parsedRules[node.dottedName]);
  return __spreadValues(__spreadProps(__spreadValues({}, node), {
    missingVariables: explanation.missingVariables,
    nodeValue: explanation.nodeValue
  }), "unit" in explanation && { unit: explanation.unit });
});

// source/format.ts
var numberFormatter = ({
  style,
  maximumFractionDigits = 2,
  minimumFractionDigits = 0,
  language
}) => (value) => {
  const adaptedMinimumFractionDigits = style === "currency" && maximumFractionDigits >= 2 && minimumFractionDigits === 0 && !Number.isInteger(value) ? 2 : minimumFractionDigits;
  return Intl.NumberFormat(language, {
    style,
    currency: "EUR",
    maximumFractionDigits,
    minimumFractionDigits: adaptedMinimumFractionDigits
  }).format(value);
};
function formatNumber({
  maximumFractionDigits,
  minimumFractionDigits,
  language,
  formatUnit: formatUnit2,
  unit,
  nodeValue
}) {
  if (typeof nodeValue !== "number") {
    return nodeValue;
  }
  const serializedUnit = unit ? serializeUnit(unit, nodeValue, formatUnit2) : void 0;
  switch (serializedUnit) {
    case "\u20AC":
      return numberFormatter({
        style: "currency",
        maximumFractionDigits,
        minimumFractionDigits,
        language
      })(nodeValue);
    case "%":
      return numberFormatter({
        style: "percent",
        maximumFractionDigits,
        language
      })(nodeValue / 100);
    default:
      return numberFormatter({
        style: "decimal",
        minimumFractionDigits,
        maximumFractionDigits,
        language
      })(nodeValue) + (typeof serializedUnit === "string" ? `\xA0${serializedUnit}` : "");
  }
}
function capitalise0(name) {
  return name && name[0].toUpperCase() + name.slice(1);
}
var booleanTranslations = {
  fr: { true: "oui", false: "non" },
  en: { true: "yes", false: "no" }
};
function formatValue(value, { language = "fr", displayedUnit, formatUnit: formatUnit2, precision = 2 } = {}) {
  let nodeValue = typeof value === "number" || typeof value === "undefined" || value === null ? value : value.nodeValue;
  if (typeof nodeValue === "number" && Number.isNaN(nodeValue)) {
    return "Erreur dans le calcul du nombre";
  }
  if (isNotYetDefined(nodeValue)) {
    return "Pas encore d\xE9fini";
  }
  if (isNotApplicable(nodeValue)) {
    return "Non applicable";
  }
  if (typeof nodeValue === "string") {
    return nodeValue.replace("\\n", "\n");
  }
  if (typeof nodeValue === "object")
    return nodeValue.nom;
  if (typeof nodeValue === "boolean")
    return booleanTranslations[language][nodeValue];
  if (typeof nodeValue === "number") {
    let unit = typeof value === "number" || typeof value === "undefined" || !("unit" in value) ? void 0 : value.unit;
    if (unit) {
      const simplifiedNode = simplifyNodeUnit({
        unit,
        nodeValue
      });
      unit = simplifiedNode.unit;
      nodeValue = simplifiedNode.nodeValue;
    }
    return formatNumber({
      minimumFractionDigits: 0,
      maximumFractionDigits: precision,
      language,
      formatUnit: formatUnit2,
      nodeValue,
      unit: displayedUnit != null ? displayedUnit : unit
    }).trim();
  }
  return void 0;
}

// source/rule.ts
function parseRule(rawRule, context) {
  var _a, _b;
  const dottedName = [context.dottedName, rawRule.nom].filter(Boolean).join(" . ");
  const name = nameLeaf(dottedName);
  const ruleTitle = capitalise0((_a = rawRule["titre"]) != null ? _a : context.ruleTitle ? `${context.ruleTitle} (${name})` : name);
  if (context.parsedRules[dottedName]) {
    throw new Error(`La r\xE9f\xE9rence '${dottedName}' a d\xE9j\xE0 \xE9t\xE9 d\xE9finie`);
  }
  const ruleValue = __spreadProps(__spreadValues(__spreadValues({}, Object.fromEntries(Object.entries(rawRule).filter(([key]) => mecanismKeys.includes(key)))), "formule" in rawRule && { valeur: rawRule.formule }), {
    "nom dans la situation": dottedName
  });
  const ruleContext = __spreadProps(__spreadValues({}, context), { dottedName, ruleTitle });
  context.parsedRules[dottedName] = void 0;
  const explanation = {
    valeur: parse(ruleValue, ruleContext),
    parents: ruleParents(dottedName).map((parent) => parse(parent, __spreadProps(__spreadValues({}, context), { circularReferences: true })))
  };
  context.parsedRules[dottedName] = {
    dottedName,
    replacements: [
      ...parseRendNonApplicable(rawRule["rend non applicable"], ruleContext),
      ...parseReplacements(rawRule.remplace, ruleContext)
    ],
    title: ruleTitle,
    suggestions: Object.fromEntries(Object.entries((_b = rawRule.suggestions) != null ? _b : {}).map(([name2, node]) => [
      name2,
      parse(node, ruleContext)
    ])),
    nodeKind: "rule",
    explanation,
    rawNode: rawRule,
    virtualRule: !!context.dottedName
  };
  return parse(rawRule.nom, context);
}
registerEvaluationFunction("rule", function evaluate22(node) {
  const firstNullableParent = node.explanation.parents.find((ref) => {
    var _a;
    return (_a = this.ruleUnits.get(ref)) == null ? void 0 : _a.isNullable;
  });
  let nullableParentEvaluation = {
    nodeValue: void 0,
    missingVariables: {}
  };
  if (firstNullableParent && !this.cache._meta.parentRuleStack.includes(node.dottedName)) {
    this.cache._meta.parentRuleStack.unshift(node.dottedName);
    nullableParentEvaluation = this.evaluate(firstNullableParent);
    this.cache._meta.parentRuleStack.shift();
  }
  const ruleDisabledByItsParent = nullableParentEvaluation.nodeValue === null || nullableParentEvaluation.nodeValue === false;
  let valeurEvaluation = __spreadProps(__spreadValues({}, node.explanation.valeur), {
    nodeValue: null,
    missingVariables: {}
  });
  if (!ruleDisabledByItsParent) {
    if (this.cache._meta.evaluationRuleStack.filter((dottedName) => dottedName === node.dottedName).length > 15) {
      warning(this.options.logger, node.dottedName, `
		Un cycle a \xE9t\xE9 d\xE9tect\xE9 dans lors de l'\xE9valuation de cette r\xE8gle.
		Par d\xE9faut cette r\xE8gle sera \xE9valu\xE9e \xE0 'null'.
		Pour indiquer au moteur de r\xE9soudre la r\xE9f\xE9rence circulaire en trouvant le point fixe
		de la fonction, il vous suffit d'ajouter l'attribut suivant niveau de la r\xE8gle :
		${node.dottedName}:
		"r\xE9soudre la r\xE9f\xE9rence circulaire: oui"
		...
		`);
      valeurEvaluation = {
        nodeValue: void 0,
        missingVariables: {}
      };
    } else {
      this.cache._meta.evaluationRuleStack.unshift(node.dottedName);
      valeurEvaluation = this.evaluate(node.explanation.valeur);
      this.cache._meta.evaluationRuleStack.shift();
    }
  }
  const parentMissing = Object.keys(nullableParentEvaluation.missingVariables);
  const selfMissing = Object.keys(valeurEvaluation.missingVariables);
  const evaluation = __spreadValues(__spreadProps(__spreadValues({}, node), {
    explanation: {
      nullableParent: nullableParentEvaluation,
      parents: node.explanation.parents,
      valeur: valeurEvaluation
    },
    nodeValue: valeurEvaluation.nodeValue,
    missingVariables: mergeMissing(valeurEvaluation.missingVariables, bonus(nullableParentEvaluation.missingVariables)),
    missing: {
      parent: parentMissing,
      self: selfMissing
    }
  }), valeurEvaluation && "unit" in valeurEvaluation && { unit: valeurEvaluation.unit });
  return evaluation;
});

// source/parse.ts
var { Grammar, Parser } = import_nearley.default;
function parse(rawNode, context) {
  if (rawNode == void 0) {
    syntaxError(context.dottedName, `
Une des valeurs de la formule est vide.
V\xE9rifiez que tous les champs \xE0 droite des deux points sont remplis`);
  }
  if (typeof rawNode === "boolean") {
    syntaxError(context.dottedName, `
Les valeurs bool\xE9ennes true / false ne sont accept\xE9es.
Utilisez leur contrepartie fran\xE7aise : 'oui' / 'non'`);
  }
  const node = typeof rawNode === "object" ? rawNode : parseExpression(rawNode, context);
  if ("nom" in node) {
    return parseRule(node, context);
  }
  return __spreadProps(__spreadValues({}, parseChainedMecanisms(node, context)), {
    rawNode
  });
}
var compiledGrammar = Grammar.fromCompiled(grammar_default);
function parseExpression(rawNode, context) {
  const singleLineExpression = (rawNode + "").replaceAll(/\s*\n\s*/g, " ").trim();
  try {
    const [parseResult] = new Parser(compiledGrammar).feed(singleLineExpression).results;
    if (parseResult == null) {
      throw new InternalError({
        expression: singleLineExpression,
        parseResult: `${JSON.stringify(parseResult)}`,
        notice: "L'erreur se situe tr\xE8s probablement dans le fichier `nearley.ne`"
      });
    }
    return parseResult;
  } catch (e) {
    if (e instanceof InternalError) {
      throw e;
    }
    syntaxError(context.dottedName, `\`${singleLineExpression}\` n'est pas une expression valide`, e);
  }
}
function parseMecanism(rawNode, context) {
  if (Array.isArray(rawNode)) {
    syntaxError(context.dottedName, `
Il manque le nom du m\xE9canisme pour le tableau : [${rawNode.map((x) => `'${x}'`).join(", ")}]
Les m\xE9canisme possibles sont : 'somme', 'le maximum de', 'le minimum de', 'toutes ces conditions', 'une de ces conditions'.
		`);
  }
  const keys = Object.keys(rawNode);
  if (keys.length > 1) {
    syntaxError(context.dottedName, `
Les m\xE9canismes suivants se situent au m\xEAme niveau : ${keys.map((x) => `'${x}'`).join(", ")}
Cela vient probablement d'une erreur dans l'indentation
	`);
  }
  if (keys.length === 0) {
    return { nodeKind: "constant", nodeValue: void 0 };
  }
  const mecanismName = Object.keys(rawNode)[0];
  const values = rawNode[mecanismName];
  const parseFn = parseFunctions[mecanismName];
  if (!parseFn) {
    syntaxError(context.dottedName, `
Le m\xE9canisme ${mecanismName} est inconnu.
V\xE9rifiez qu'il n'y ait pas d'erreur dans l'orthographe du nom.`);
  }
  try {
    if (values == null ? void 0 : values.composantes) {
      return decompose(mecanismName, values, context);
    }
    if ((values == null ? void 0 : values.variations) && Object.values(values).length > 1) {
      return devariate(mecanismName, values, context);
    }
    return parseFn(values, context);
  } catch (e) {
    if (e instanceof EngineError) {
      throw e;
    }
    syntaxError(context.dottedName, mecanismName ? `\u27A1\uFE0F Dans le m\xE9canisme ${mecanismName}
${e.message}` : e.message);
  }
}
var chainableMecanisms = [
  parseApplicable,
  parseNonApplicable,
  parseArrondi,
  parseUnit\u00E9,
  Plancher,
  parsePlafond,
  parseParD\u00E9faut,
  parseSituation,
  parseR\u00E9soudreR\u00E9f\u00E9renceCirculaire,
  parseAbattement
];
function parseChainedMecanisms(rawNode, context) {
  var _a;
  const parseFn = chainableMecanisms.find((fn) => fn.nom in rawNode);
  if (!parseFn) {
    return parseMecanism(rawNode, context);
  }
  const _b = rawNode, { [_a = parseFn.nom]: param } = _b, valeur = __objRest(_b, [__restKey(_a)]);
  return parseMecanism({
    [parseFn.nom]: {
      valeur,
      [parseFn.nom]: param
    }
  }, context);
}
var parseFunctions = __spreadProps(__spreadValues(__spreadValues({}, operation_default), chainableMecanisms.reduce((acc, fn) => __spreadValues({ [fn.nom]: fn }, acc), {})), {
  "inversion num\xE9rique": mecanismInversion,
  "le maximum de": mecanismMax,
  "le minimum de": mecanismMin,
  "taux progressif": parseTauxProgressif,
  "toutes ces conditions": mecanismAllOf,
  "une de ces conditions": mecanismOneOf,
  "une possibilit\xE9": mecanismOnePossibility,
  bar\u00E8me: parseBar\u00E8me,
  dur\u00E9e: dur_e_default,
  grille: parseGrille,
  multiplication: mecanismProduct,
  produit: mecanismProduct,
  recalcul: mecanismRecalcul,
  somme: mecanismSum,
  synchronisation: mecanismSynchronisation,
  [parseTexte.nom]: parseTexte,
  valeur: parse,
  variable: parseReference,
  variations: parseVariations,
  objet: (v) => ({
    type: "objet",
    nodeValue: v,
    nodeKind: "constant"
  }),
  constant: (v) => ({
    type: v.type,
    fullPrecision: true,
    nodeValue: v.nodeValue,
    nodeKind: "constant"
  })
});
var mecanismKeys = Object.keys(parseFunctions);

// source/serializeEvaluation.ts
function serializeEvaluation(node) {
  if (typeof node.nodeValue === "number") {
    const serializedUnit = serializeUnit(node.unit);
    return "" + node.nodeValue + (serializedUnit ? serializedUnit.replace(/\s/g, "") : "");
  } else if (typeof node.nodeValue === "boolean") {
    return node.nodeValue ? "oui" : "non";
  } else if (typeof node.nodeValue === "string") {
    return `'${node.nodeValue}'`;
  }
}

// source/index.ts
var emptyCache = () => ({
  _meta: {
    evaluationRuleStack: [],
    parentRuleStack: []
  },
  nodes: /* @__PURE__ */ new Map(),
  nodesApplicability: /* @__PURE__ */ new Map()
});
var Engine = class {
  parsedRules;
  parsedSituation = {};
  replacements = {};
  cache = emptyCache();
  options;
  subEngines = [];
  subEngineId;
  ruleUnits;
  constructor(rules = {}, options = {}) {
    var _a;
    this.options = __spreadProps(__spreadValues({}, options), { logger: (_a = options.logger) != null ? _a : console });
    const { parsedRules, ruleUnits } = parsePublicodes2(rules, this.options);
    this.parsedRules = parsedRules;
    this.ruleUnits = ruleUnits;
    this.replacements = getReplacements(this.parsedRules);
  }
  setOptions(options) {
    this.options = __spreadValues(__spreadValues({}, this.options), options);
  }
  resetCache() {
    this.cache = emptyCache();
  }
  setSituation(situation = {}) {
    this.resetCache();
    this.parsedSituation = Object.fromEntries(Object.entries(situation).map(([key, value]) => {
      if (value && typeof value === "object" && "nodeKind" in value) {
        return [key, value];
      }
      const parsedValue = value && typeof value === "object" && "nodeKind" in value ? value : this.parse(value, __spreadValues({
        dottedName: `situation [${key}]`,
        parsedRules: {}
      }, this.options));
      return [key, parsedValue];
    }));
    return this;
  }
  parse(...args) {
    return inlineReplacements(this.replacements, this.options.logger)(disambiguateReferenceAndCollectDependencies(this.parsedRules, {})(parse(...args)));
  }
  inversionFail() {
    return !!this.cache._meta.inversionFail;
  }
  getRule(dottedName) {
    if (!(dottedName in this.parsedRules)) {
      throw new Error(`La r\xE8gle '${dottedName}' n'existe pas`);
    }
    return this.parsedRules[dottedName];
  }
  getParsedRules() {
    return this.parsedRules;
  }
  getOptions() {
    return this.options;
  }
  evaluate(value) {
    const cachedNode = this.cache.nodes.get(value);
    if (cachedNode !== void 0) {
      return cachedNode;
    }
    let parsedNode;
    if (!value || typeof value !== "object" || !("nodeKind" in value)) {
      parsedNode = this.parse(value, __spreadValues({
        dottedName: "evaluation",
        parsedRules: {}
      }, this.options));
    } else {
      parsedNode = value;
    }
    if (!evaluationFunctions[parsedNode.nodeKind]) {
      throw Error(`Unknown "nodeKind": ${parsedNode.nodeKind}`);
    }
    const evaluatedNode = evaluationFunctions[parsedNode.nodeKind].call(this, parsedNode);
    this.cache.nodes.set(value, evaluatedNode);
    return evaluatedNode;
  }
  shallowCopy() {
    const newEngine = new Engine();
    newEngine.options = this.options;
    newEngine.parsedRules = this.parsedRules;
    newEngine.replacements = this.replacements;
    newEngine.parsedSituation = this.parsedSituation;
    newEngine.ruleUnits = this.ruleUnits;
    newEngine.cache = this.cache;
    newEngine.subEngineId = this.subEngines.length;
    this.subEngines.push(newEngine);
    return newEngine;
  }
};
function UNSAFE_isNotApplicable(engine, dottedName) {
  var _a;
  return ((_a = engine.ruleUnits.get(engine.parsedRules[dottedName])) == null ? void 0 : _a.isNullable) === true && engine.evaluate(dottedName).nodeValue === null;
}
module.exports = __toCommonJS(source_exports);
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  UNSAFE_isNotApplicable,
  capitalise0,
  formatValue,
  isNotApplicable,
  isNotYetDefined,
  parsePublicodes,
  parseUnit,
  reduceAST,
  serializeEvaluation,
  serializeUnit,
  simplifyNodeUnit,
  transformAST,
  utils
});
//# sourceMappingURL=index.cjs.map